
if (typeof global.process === "undefined") {
  global.process = require("process/browser");
}
import leafletImage from "leaflet-image";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginRegister from "./LoginRegister";

import { Search } from "lucide-react";
import Header from "./Header"; // ✅ استيراد الهيدر
import App from "./App.css"; // ✅ استيراد ملف CSS
import React, { useState, useEffect, useRef, useCallback } from "react";

// ✅✅✅ مهم: useMapEvents/useMap لازم يفضلوا من react-leaflet (مش react-router-dom)
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  GeoJSON,
  Popup,
  LayersControl,
  Marker,
  Polyline,
  useMapEvents,
  useMap,
} from "react-leaflet";

import { EditControl } from "react-leaflet-draw";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import * as turf from "@turf/turf";
import shp from "shpjs";
import shpjs from "shpjs"; // استيراد shpjs لتحويل GeoJSON إلى Shapefile
// import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
const shpwrite = require("shp-write");
import JSZip from "jszip";
import { saveAs } from "file-saver";
// import { jsPDF } from "jspdf";
// import process from "process";
import { jsPDF } from "jspdf";
import XLSX from "xlsx/dist/xlsx.full.min";
import tokml from "tokml";
import { area } from "@turf/turf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { useLayoutEffect } from "react";
import L from "leaflet";
import "./MapOverrides.css";
import "./Sobek.css";
import "./mobile-only.css";

// ✅ أيقونة الدبوس المخصصة
const pinIcon = new L.Icon({
  iconUrl: "https://maps.google.com/mapfiles/kml/shapes/placemark_circle.png", // أيقونة دبوس من جوجل
  iconSize: [30, 30], // حجم الأيقونة
  iconAnchor: [15, 30], // النقطة المرجعية للدبوس
  popupAnchor: [0, -30], // موضع البوب-أب
});

const process = require("process/browser");

const Sobek = () => {

  // ✅✅✅ Mobile viewport fix (prevents the whole UI from looking zoomed-out on phones)
  useEffect(() => {
    try {
      let meta = document.querySelector('meta[name="viewport"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'viewport');
        document.head.appendChild(meta);
      }
      meta.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover'
      );
    } catch (e) {
      // no-op
    }
  }, []);

  const [shapes, setShapes] = useState([]);
  const [clickedPoint, setClickedPoint] = useState(null);
  const [shapeDetails, setShapeDetails] = useState(null);
  const [edgeMeasureMode, setEdgeMeasureMode] = useState(false); // ✅ قياس الأضلاع بالضغط على ضلع
  const [edgeMeasurement, setEdgeMeasurement] = useState(null); // ✅ { lengthKm, lengthM, from, to }
  const [edgeLengths, setEdgeLengths] = useState([]); // ✅ طول كل ضلع (نستخدمه داخلياً فقط)
  const [uploadedLayers, setUploadedLayers] = useState([]); // (موجود عندك للـ email attachments - لم ألمسه)
  const [selectedTab, setSelectedTab] = useState(() => {
    try {
      return localStorage.getItem("sobek_selectedTab") || "details";
    } catch (e) {
      return "details";
    }
  });
  const [startDate, setStartDate] = useState("1970-01-01"); // التاريخ الافتراضي
  const [endDate, setEndDate] = useState("2025-05-02"); // التاريخ الافتراضي
  const [showPopup, setShowPopup] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [email, setEmail] = useState("rania@sobekglobal.com");
  const [resolution, setResolution] = useState(30); // Default resolution
  const [cloudAverage, setCloudAverage] = useState(50); // Default cloud average
  const [nadirAngle, setNadirAngle] = useState(0); // Default nadir angle
  const [selectedOption, setSelectedOption] = useState("satellite"); // Default option
  const [notes, setNotes] = useState("");
  const [drawingCoordinates, setDrawingCoordinates] = useState([]); // تخزين إحداثيات الرسم أثناء الرسم
  const [mapCenter, setMapCenter] = useState([51.505, -0.09]); // ✅ الموقع الافتراضي
  const [markerPosition, setMarkerPosition] = useState(null); // ✅ موقع الدبوس
  const [popupOpen, setPopupOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDragging, setIsDragging] = useState(false); // Flag to track if the user is dragging
  const [trackColor, setTrackColor] = useState("#ff9f00"); // Track color
  const [allowShareTab, setAllowShareTab] = useState(false);

  const resolutionSliderRef = useRef(null); // Reference to resolution slider
  const cloudCoverSliderRef = useRef(null); // Reference to cloud cover slider
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const nadirAngleSliderRef = useRef(null); // Reference to nadir angle slider
  const [popupForceUpdate, setPopupForceUpdate] = useState(0);
  const [mapInstance, setMapInstance] = useState(null);
  const [isUploadDisabled, setIsUploadDisabled] = useState(false);
  const fileInputRef = useRef(null);
  const [customAlert, setCustomAlert] = useState(null);

  const mapRef = useRef(null);
  const pendingUploadBoundsRef = useRef(null); // ✅ zoom to uploaded shapefile bounds
  const [isMapReady, setIsMapReady] = useState(false);
  const drawRef = useRef();
  const drawControlRef = useRef();
  const activeDrawTypeRef = useRef(null); // ✅ limit polyline to 2 points
  const [showWelcomeMessage, setShowWelcomeMessage] = useState(false);

  // ✅✅✅ NEW: segment labels shown on map when measuring (each edge length)
  const [segmentLabels, setSegmentLabels] = useState([]);

  // Circle measurement helpers (radius line + label)
  const [circleMeasureLine, setCircleMeasureLine] = useState(null); // [[lat,lng],[lat,lng]]
  const [circleRadiusLabel, setCircleRadiusLabel] = useState(null); // { lat, lng, text }


  // ✅ Derived: if current selected upload layer is hidden, hide vertex/segment markers (but keep panel state)
  const currentUploadGroupId = shapeDetails?.featureGeoJSON?.properties?.uploadGroupId;

  // ✅✅✅ NEW: Uploaded layers as real LAYERS in the tab with show/hide
  const [uploadedMapLayers, setUploadedMapLayers] = useState([]);

  const isCurrentUploadLayerHidden =
    shapeDetails?.featureGeoJSON?.properties?.source === "upload" &&
    Array.isArray(uploadedMapLayers) &&
    uploadedMapLayers.some((g) => g.id === currentUploadGroupId && g.visible === false);
 // [{id, lat, lng, text}]

  // ✅ Accordion state for Uploaded Layers (arrow next to checkbox)
  const [expandedUploadGroups, setExpandedUploadGroups] = useState({});

  // [{ id:'upl-points', name:'Points', geomType:'Point', visible:true, layerIds:[...] }, ...]
  const uploadedLayerObjectsRef = useRef(new Map()); // leaflet_id => leaflet layer object

  // ✅ keep a copy of hidden uploaded features so we can restore them on show
  const hiddenUploadedFeaturesRef = useRef(new Map()); // groupId => Feature[]

  // ✅✅✅ NEW: hide Leaflet-Draw vertex squares أثناء الرسم فقط
  const [isDrawingNow, setIsDrawingNow] = useState(false);

  // ✅✅✅ NEW: Finish polygon on dblclick (DOM capture) — Polygon ONLY
  const polygonDblListenerRef = useRef(null);
  const dblZoomWasEnabledRef = useRef(true);

  // =======================
  // ✅✅✅ Helpers: Area formatting (km²)
  // =======================
  const toKm2 = (m2) => m2 / 1_000_000;
  const fmtKm2 = (m2) => {
    const v = toKm2(m2);
    // 4 decimals عشان تبان صح حتى في المساحات الصغيرة
    return Number.isFinite(v) ? v.toFixed(4) : "0.0000";
  };

  // =======================
  // ✅✅✅ Single-shape lock (no new draw/upload until delete)
  // =======================
  const hasAnyShape = (Array.isArray(shapes) && shapes.length > 0) || (Array.isArray(uploadedMapLayers) && uploadedMapLayers.length > 0);

  // === Leaflet.Draw mode helpers (prevent one tool from breaking another) ===
  const getDrawControl = () => drawControlRef.current;

  const installPolygonDblClickFinish = () => {
    const map = mapRef.current;
    if (!map) return;

    // avoid installing twice
    if (polygonDblListenerRef.current) return;

    // remember dblclick zoom state then disable it أثناء رسم البوليجون
    try {
      dblZoomWasEnabledRef.current = !!map.doubleClickZoom?.enabled?.();
      map.doubleClickZoom?.disable?.();
    } catch {}

    const container = map.getContainer?.();
    if (!container) return;

    const handler = (ev) => {
      try {
        const h = getDrawControl()?._toolbars?.draw?._modes?.polygon?.handler;
      // ✅ Prevent the extra vertex created by the 2nd click in a double‑click finish
      try {
        const mk = h?._markers;
        if (Array.isArray(mk) && mk.length >= 2) {
          const lastLL = mk[mk.length - 1]?.getLatLng?.();
          const prevLL = mk[mk.length - 2]?.getLatLng?.();
          const same =
            lastLL &&
            prevLL &&
            Math.abs(lastLL.lat - prevLL.lat) < 1e-12 &&
            Math.abs(lastLL.lng - prevLL.lng) < 1e-12;
          if (same) {
            const lastMk = mk.pop();
            try { h?._markerGroup?.removeLayer?.(lastMk); } catch (_) {}
            try { map?.removeLayer?.(lastMk); } catch (_) {}
            try {
              if (h?._poly && Array.isArray(h._poly._latlngs) && h._poly._latlngs.length) {
                h._poly._latlngs.pop();
                h._poly.redraw?.();
              }
            } catch (_) {}
          }
        }
      } catch (_) {}


        // ✅ شغال فقط لو polygon mode enabled
        if (!h || typeof h.enabled !== "function" || !h.enabled()) return;

        // امنع أي سلوك افتراضي / زوم
        ev.preventDefault?.();
        ev.stopPropagation?.();

        // ✅ إنهاء الشكل فورًا بدون الرجوع لأول نقطة
        if (typeof h._finishShape === "function") {
          h._finishShape();
        } else if (typeof h.completeShape === "function") {
          h.completeShape();
        } else if (typeof h._onFinish === "function") {
          h._onFinish();
        }
      } catch (e) {
        console.warn("dblclick finish polygon failed:", e);
      }
    };

    polygonDblListenerRef.current = handler;

    // ✅ CAPTURE = true عشان نمسك الحدث قبل Leaflet
    container.addEventListener("dblclick", handler, true);
  };

  const removePolygonDblClickFinish = () => {
    const map = mapRef.current;
    if (!map) return;

    const container = map.getContainer?.();
    const handler = polygonDblListenerRef.current;

    if (container && handler) {
      container.removeEventListener("dblclick", handler, true);
    }

    polygonDblListenerRef.current = null;

    // restore dblclick zoom state
    try {
      if (dblZoomWasEnabledRef.current) map.doubleClickZoom?.enable?.();
      else map.doubleClickZoom?.disable?.();
    } catch {}
  };

  const disablePolygonDrawMode = () => {
    try {
      const h = getDrawControl()?._toolbars?.draw?._modes?.polygon?.handler;
      if (h && typeof h.enabled === "function" && h.enabled()) h.disable();
    } catch (err) {
      console.warn("disablePolygonDrawMode failed:", err);
    }
  };

  const disableRectangleDrawMode = () => {
    try {
      const h = getDrawControl()?._toolbars?.draw?._modes?.rectangle?.handler;
      if (h && typeof h.enabled === "function" && h.enabled()) h.disable();
    } catch (err) {
      console.warn("disableRectangleDrawMode failed:", err);
    }
  };

  const disableCircleDrawMode = () => {
    try {
      const h = getDrawControl()?._toolbars?.draw?._modes?.circle?.handler;
      if (h && typeof h.enabled === "function" && h.enabled()) h.disable();
    } catch (err) {
      console.warn("disableCircleDrawMode failed:", err);
    }
  };

  // ✅✅✅ NEW: disable polyline too (كان هو اللي بيفضل مفتوح)
  const disablePolylineDrawMode = () => {
    try {
      const h = getDrawControl()?._toolbars?.draw?._modes?.polyline?.handler;
      if (h && typeof h.enabled === "function" && h.enabled()) h.disable();
    } catch (err) {
      console.warn("disablePolylineDrawMode failed:", err);
    }
  };

  const disableAllDrawModes = () => {
    disablePolygonDrawMode();
    disableRectangleDrawMode();
    disableCircleDrawMode();
    disablePolylineDrawMode(); // ✅✅✅ مهم
  };

  // ✅✅✅ NEW: disable all except currently active tool
  const disableAllDrawModesExcept = (active) => {
    try {
      if (active !== "polygon") disablePolygonDrawMode();
      if (active !== "rectangle") disableRectangleDrawMode();
      if (active !== "circle") disableCircleDrawMode();
      if (active !== "polyline") disablePolylineDrawMode();
    } catch (e) {
      console.warn("disableAllDrawModesExcept failed:", e);
    }
  };

  const disableEditMode = () => {
    try {
      const h = getDrawControl()?._toolbars?.edit?._modes?.edit?.handler;
      if (h && typeof h.enabled === "function" && h.enabled()) h.disable();
    } catch (err) {
      console.warn("disableEditMode failed:", err);
    }
  };

  const disableDeleteMode = () => {
    try {
      const h = getDrawControl()?._toolbars?.edit?._modes?.remove?.handler;
      if (h && typeof h.enabled === "function" && h.enabled()) h.disable();
    } catch (err) {
      console.warn("disableDeleteMode failed:", err);
    }
  };

  // Disable/Enable draw buttons (polygon/rectangle/circle/polyline)
  const disableDrawingTools = () => {
    try {
      const selectors = [
        ".leaflet-draw-draw-polygon",
        ".leaflet-draw-draw-rectangle",
        ".leaflet-draw-draw-circle",
        ".leaflet-draw-draw-polyline", // ✅✅✅ NEW
      ];
      selectors.forEach((sel) => {
        const btns = document.querySelectorAll(sel);
        btns.forEach((btn) => {
          btn.style.pointerEvents = "none";
          btn.style.opacity = "0.5";
          btn.style.cursor = "not-allowed";
          btn.title = "الرسم معطل - احذفي الشكل الحالي أولاً";
        });
      });

      const container = document.querySelector(".leaflet-container");
      if (container) container.style.cursor = "not-allowed";
    } catch (e) {
      console.warn("disableDrawingTools failed:", e);
    }
  };

  const enableDrawingTools = () => {
    try {
      const selectors = [
        ".leaflet-draw-draw-polygon",
        ".leaflet-draw-draw-rectangle",
        ".leaflet-draw-draw-circle",
        ".leaflet-draw-draw-polyline", // ✅✅✅ NEW
      ];
      selectors.forEach((sel) => {
        const btns = document.querySelectorAll(sel);
        btns.forEach((btn) => {
          btn.style.pointerEvents = "auto";
          btn.style.opacity = "1";
          btn.style.cursor = "pointer";
          btn.title = "رسم شكل جديد";
        });
      });

      const container = document.querySelector(".leaflet-container");
      if (container) container.style.cursor = "";
    } catch (e) {
      console.warn("enableDrawingTools failed:", e);
    }
  };

  // ✅ lock behavior: if any shape exists => disable upload + disable draw tools
  useEffect(() => {
    try {
      localStorage.setItem("sobek_selectedTab", selectedTab);
    } catch (e) {}
  }, [selectedTab]);

  useEffect(() => {
    if (hasAnyShape) {
      setIsUploadDisabled(true);
      disableDrawingTools();
      // كمان اقفل أي وضع رسم لو كان شغال
      disableAllDrawModes();
      removePolygonDblClickFinish(); // ✅✅✅ مهم
    } else {
      setIsUploadDisabled(false);
      enableDrawingTools();
      removePolygonDblClickFinish(); // ✅✅✅ مهم
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAnyShape]);

  // Remove previous *drawn* polygon so draw tool produces only ONE polygon (uploads stay)
  const removePreviousDrawnPolygons = (keepLayerId) => {
    try {
      const fg = featureGroupRef.current;
      if (!fg || typeof fg.getLayers !== "function") return;

      fg.getLayers().forEach((l) => {
        if (l && l.__sobekSource === "draw" && l._leaflet_id !== keepLayerId) {
          fg.removeLayer(l);
        }
      });
    } catch (err) {
      console.warn("removePreviousDrawnPolygons failed:", err);
    }
  };

  // When user switches to edit/delete, stop drawing immediately (prevents draw re-opening)
  const handleEditStart = () => {
    setIsDrawingNow(false); // ✅ hide vertex squares only during draw
    disableAllDrawModes();
    removePolygonDblClickFinish(); // ✅✅✅ مهم
  };

  // ✅ Force-hide "Save" button in Leaflet-Draw actions (delete mode)
  const forceHideDeleteSave = () => {
    try {
      // Leaflet puts the actions toolbar inside .leaflet-top.leaflet-right
      const mapEl = document.querySelector(".leaflet-container");
      if (!mapEl) return;

      // hide first action item (usually Save) in any visible actions bar
      const actionBars = mapEl.querySelectorAll(".leaflet-draw-actions");
      actionBars.forEach((bar) => {
        const firstLi = bar.querySelector("li:first-child");
        if (firstLi) firstLi.style.display = "none";
      });

      // extra fallback: hide any anchor whose title/text contains Save
      const saveLinks = mapEl.querySelectorAll(
        '.leaflet-draw-actions a[title*="Save"], .leaflet-draw-actions a[title*="save"]'
      );
      saveLinks.forEach((a) => (a.style.display = "none"));
    } catch (e) {
      console.warn("forceHideDeleteSave failed:", e);
    }
  };

  const handleEditStop = () => {
    setIsDrawingNow(false);
    removePolygonDblClickFinish(); // ✅✅✅ مهم
  };
  const handleDeleteStart = () => {
    setIsDrawingNow(false); // ✅
    disableAllDrawModes();
    removePolygonDblClickFinish(); // ✅✅✅ مهم
    setTimeout(() => forceHideDeleteSave(), 0);
    setTimeout(() => forceHideDeleteSave(), 50);
    setTimeout(() => forceHideDeleteSave(), 150);
    // ✅✅✅ (1) شيل الـ Save من الديليت: نخفي أزرار الـ actions وقت الـ delete
    // ✅✅✅ (2) نخلي الحذف "فوري" بدون Save: auto-save بعد كل click حذف
    try {
      const del = getDrawControl()?._toolbars?.edit?._modes?.remove?.handler;
      if (del && !del.__sobekAutoSavePatched) {
        const originalRemoveLayer = del._removeLayer?.bind(del);

        if (typeof originalRemoveLayer === "function") {
          del._removeLayer = function (e) {
            // نفّذ حذف اللياف
            originalRemoveLayer(e);

            // ✅ auto-save immediately (fires draw:deleted + triggers onDeleted)
            try {
              if (typeof this.save === "function") this.save();
            } catch (err) {
              console.warn("auto-save after delete failed:", err);
            }
          };

          del.__sobekAutoSavePatched = true;
        }
      }
    } catch (err) {
      console.warn("patch delete handler failed:", err);
    }
  };
  const handleDeleteStop = () => {
    setIsDrawingNow(false);
    removePolygonDblClickFinish(); // ✅✅✅ مهم
  };

  useEffect(() => {
    setShowWelcomeMessage(true);
  }, []);
  useEffect(() => {
    try {
      const map = mapRef.current;
      const b = pendingUploadBoundsRef.current;
      if (map && b && typeof b.isValid === "function" && b.isValid()) {
        map.fitBounds(b, { padding: [40, 40], maxZoom: 18 });
        pendingUploadBoundsRef.current = null;
      }
    } catch (e) {}
  }, [isMapReady]);


  // === computed strings to avoid inline template literals in JSX styles ===
  const resPct = (resolution / 500) * 100;
  const nadirPct = (nadirAngle / 90) * 100;
  const cloudPct = cloudAverage; // 0..100
  const resolutionBg = `linear-gradient(to right, #ff9f00 ${resPct}%, #cccccc ${resPct}%)`;
  const cloudBg = `linear-gradient(to right, #ff9f00 ${cloudPct}%, #cccccc ${cloudPct}%)`;
  const nadirBg = `linear-gradient(to right, #ff9f00 ${nadirPct}%, #cccccc ${nadirPct}%)`;

  console.log("🌍 Map reference:", mapRef.current);

  // Handling mouse down event to start dragging
  const handleMouseDown = () => {
    setIsDragging(true);
  };

  // Handling mouse move to update the value of slider and box position
  const handleMouseMove = (e, sliderType) => {
    if (isDragging) {
      let newValue;
      let sliderWidth, sliderLeft;

      // Calculating new value for resolution, cloud cover, and nadir angle
      if (sliderType === "resolution") {
        sliderWidth = resolutionSliderRef.current.getBoundingClientRect().width;
        sliderLeft = resolutionSliderRef.current.getBoundingClientRect().left;
        newValue = Math.min(Math.max(0, (e.clientX - sliderLeft) / sliderWidth), 1) * 490 + 10; // 10 cm to 500 cm
        newValue = Math.round(newValue / 10) * 10; // Round to nearest 10 cm
        setResolution(newValue);
      } else if (sliderType === "cloudCover") {
        sliderWidth = cloudCoverSliderRef.current.getBoundingClientRect().width;
        sliderLeft = cloudCoverSliderRef.current.getBoundingClientRect().left;
        newValue = Math.min(Math.max(0, (e.clientX - sliderLeft) / sliderWidth), 1) * 100; // 0% to 100%
        newValue = Math.round(newValue / 10) * 10; // Round to nearest 10%
        setCloudAverage(newValue);
      } else if (sliderType === "nadirAngle") {
        sliderWidth = nadirAngleSliderRef.current.getBoundingClientRect().width;
        sliderLeft = nadirAngleSliderRef.current.getBoundingClientRect().left;
        newValue = Math.min(Math.max(0, (e.clientX - sliderLeft) / sliderWidth), 1) * 90; // 0% to 90%
        newValue = Math.round(newValue / 10) * 10; // Round to nearest 10%
        setNadirAngle(newValue);
      }
    }
  };

  // When mouse is up, stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const updateTrackColor = (value, sliderType) => {
    const color = `rgb(${Math.min(value * 128, 255)}, ${Math.min(255 - value * 128, 255)}, 0)`; // Dynamic color based on value
    if (sliderType === "resolution") {
      setTrackColor(color); // Update color for resolution slider
    }
  };

  // استخدام ref للتفاعل مع input
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  // عند الضغط على الأيقونة، نقوم بفتح نافذة اختيار التاريخ
  const openStartDatePicker = () => {
    if (startDateRef.current) {
      startDateRef.current.showPicker(); // استخدام showPicker لفتح نافذة التاريخ مباشرة
    }
  };

  const openEndDatePicker = () => {
    if (endDateRef.current) {
      endDateRef.current.showPicker(); // استخدام showPicker لفتح نافذة التاريخ مباشرة
    }
  };

  // ✅ أيقونة الدبوس المخصصة (ثانية – سبتّها باسم مختلف لتفادي التعارض بدون حذف)
  const pinIcon2 = new L.Icon({
    iconUrl: "https://maps.google.com/mapfiles/kml/shapes/placemark_circle.png",
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -30],
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const el = document.querySelector(".leaflet-control-layers");
      if (el) {
        el.style.display = "block";
        el.style.opacity = "1";
        el.style.zIndex = "9999";
        el.style.pointerEvents = "auto";
        clearInterval(interval);
      }
    }, 500);
  }, []);

  useEffect(() => {
    const storedSearchTerm = localStorage.getItem("searchTerm");
    if (storedSearchTerm) {
      setSearchTerm(storedSearchTerm);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("searchTerm", searchTerm);
  }, [searchTerm]);

  const resolutionOptions = [
    30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 250, 300, 350, 400, 450, 500, 750, 1000, 1250, 1500,
  ];

  const [selectedDataTypes, setSelectedDataTypes] = useState([]);

  const handleCheckboxChange = (type) => {
    setSelectedDataTypes((prev) =>
      prev.includes(type) ? prev.filter((item) => item !== type) : [...prev, type]
    );
  };

  // ✅ عند بدء الرسم، فتح القائمة ومسح أي إحداثيات سابقة
  const handleDrawStart = (e) => {
    // ✅ ممنوع ترسمي لو فيه شكل موجود
    if (hasAnyShape) {
      setCustomAlert("لا يمكن رسم شكل جديد أو رفع ملف قبل حذف الشكل الحالي.");
      // اقفل أي draw mode بدأ
      disableAllDrawModes();
      setIsDrawingNow(false);
      removePolygonDblClickFinish(); // ✅✅✅ مهم
      return;
    }

    // ✅ when drawing starts, make sure edit/delete tools are OFF
    disableEditMode();
    disableDeleteMode();

    // ✅ FIX: always switch to Details tab when user starts drawing (not Share)
    try {
      setSelectedTab("details");
      try { localStorage.setItem("sobek_selectedTab", "details"); } catch (e) {}
    } catch (e) {}

    // ✅✅✅ NEW: اقفل كل التولز الأخرى، وسيب التول الحالية شغالة فقط (حل مشكلة بقاء الـ line مفتوح)
    const activeType = e?.layerType; // "polyline" | "polygon" | "rectangle" | "circle" ...
    try {
      const _m = mapRef?.current;
      const _el = _m && _m.getContainer ? _m.getContainer() : document.querySelector(".leaflet-container");
      if (_el) {
        if (activeType === "polyline") _el.classList.add("sobek-hide-line-actions");
        else _el.classList.remove("sobek-hide-line-actions");
      }
    } catch (e) {}
    if (activeType) {
      disableAllDrawModesExcept(activeType);
    } else {
      // احتياطي
      disableAllDrawModes();
    }

    // ✅✅✅ NEW: polygon only -> finish on dblclick (DOM capture)
    if (activeType === "polygon") {
      installPolygonDblClickFinish();
    } else {
      removePolygonDblClickFinish();
    }

    setIsDrawingNow(true); // ✅ hide vertex squares أثناء الرسم فقط
    setDrawingCoordinates([]);
    setSegmentLabels([]); // ✅ clear segment labels when starting a fresh drawing
    setPopupOpen(true);
    setShowPopup(true);
  };

  // ✅ لما تفتح البوب اب
  const handleOpenPopup = () => {
    setShowPopup(true);
    setPopupOpen(true);
  };

  // ✅ لما تقفل البوب اب
  const handleClosePopup = () => {
    setShowPopup(false);
    setPopupOpen(false);
    setIsDrawingNow(false);
    removePolygonDblClickFinish(); // ✅✅✅ مهم
  };

  const openPopupFully = () => {
    setShowPopup(true);
    setPopupOpen(true);
  };

  // ✅✅✅ FIX: draw vertex event sometimes doesn't have eachLayer - make it robust so coords never "disappear"
  const handleVertexAdded = (e) => {
    try {
      const group = e?.layers || e?.layer || null;

      let layersArr = [];
      if (group?.getLayers && typeof group.getLayers === "function") {
        layersArr = group.getLayers();
      } else if (group?.eachLayer && typeof group.eachLayer === "function") {
        // keep compat
        group.eachLayer((l) => layersArr.push(l));
      } else if (group?._layers && typeof group._layers === "object") {
        layersArr = Object.values(group._layers);
      } else if (Array.isArray(group)) {
        layersArr = group;
      } else {
        layersArr = [];
      }

      layersArr.forEach((layer) => {
        if (layer && typeof layer.getLatLng === "function") {
          const latlng = layer.getLatLng();
          const newPoint = {
            lat: latlng.lat.toFixed(6),
            lng: latlng.lng.toFixed(6),
          };

          setDrawingCoordinates((prev) => {
            const isDuplicate = prev.some(
              (point) => String(point.lat) === String(newPoint.lat) && String(point.lng) === String(newPoint.lng)
            );
            return isDuplicate ? prev : [...prev, newPoint];
          });
        }
      });

      // ✅ keep popup visible while drawing
      setShowPopup(true);
      setPopupOpen(true);
    } catch (error) {
      console.error("Error in handleVertexAdded:", error);
      // ✅ fallback: do NOT hide anything
      setShowPopup(true);
      setPopupOpen(true);
    }
  };

  const featureGroupRef = useRef();

  // =========================
  // ✅ Helpers: Coordinates + Edge lengths
  // =========================
  const _sameCoord = (a, b) => {
    if (!a || !b) return false;
    return String(a.lat) === String(b.lat) && String(a.lng) === String(b.lng);
  };

  const _normalizeDisplayCoords = (coords) => {
    if (!Array.isArray(coords)) return [];
    if (coords.length >= 2) {
      const first = coords[0];
      const last = coords[coords.length - 1];
      // لو آخر نقطة = أول نقطة (closing ring) نشيلها من العرض
      if (_sameCoord(first, last)) return coords.slice(0, -1);
    }
    return coords;
  };

  const _calcEdgeLengths = (coords, isClosed) => {
  const c = _normalizeDisplayCoords(coords);
  const out = [];

  const _looksProjected = (lng, lat) => {
    const ax = Math.abs(Number(lng));
    const ay = Math.abs(Number(lat));
    if (!Number.isFinite(ax) || !Number.isFinite(ay)) return false;
    return ax > 200 || ay > 100;
  };

  const projected = c?.[0] ? _looksProjected(c[0].lng, c[0].lat) : false;

  const _distKm = (a, b) => {
    const x1 = Number(a.lng), y1 = Number(a.lat);
    const x2 = Number(b.lng), y2 = Number(b.lat);
    if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) return 0;

    if (projected) {
      const dx = x2 - x1;
      const dy = y2 - y1;
      const m = Math.sqrt(dx * dx + dy * dy);
      return m / 1000;
    }

    return turf.distance(turf.point([x1, y1]), turf.point([x2, y2]), { units: "kilometers" });
  };

  for (let i = 0; i < c.length; i++) {
    const nextIndex = i + 1;
    if (nextIndex >= c.length) {
      if (!isClosed || c.length < 2) {
        out.push(null);
        continue;
      }
    }
    const a = c[i];
    const b = c[(i + 1) % c.length];
    const km = _distKm(a, b);

    out.push({
      km: Number.isFinite(km) ? km : 0,
      m: Number.isFinite(km) ? km * 1000 : 0,
      from: a,
      to: b,
    });
  }
  return out;
};


  const _extractFirstRingCoords = (feature) => {
    if (!feature || !feature.geometry) return [];
    if (feature.geometry.type === "Polygon") return feature.geometry.coordinates?.[0] || [];
    if (feature.geometry.type === "MultiPolygon") return feature.geometry.coordinates?.[0]?.[0] || [];
    return [];
  };

  const _featureToDisplayCoords = (feature) => {
  // expects GeoJSON Feature
  if (!feature?.geometry) return [];
  if (feature.geometry.type === "LineString") {
    const raw = feature.geometry.coordinates || [];
    return raw.map(([lng, lat]) => ({
      lat: parseFloat(lat).toFixed(6),
      lng: parseFloat(lng).toFixed(6),
    }));
  }
  if (feature.geometry.type === "MultiLineString") {
    const lines = feature.geometry.coordinates || [];
    const firstLine = Array.isArray(lines) && Array.isArray(lines[0]) ? lines[0] : [];
    return (firstLine || []).map(([lng, lat]) => ({
      lat: parseFloat(lat).toFixed(6),
      lng: parseFloat(lng).toFixed(6),
    }));
  }
  if (feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon") {
    const raw = _extractFirstRingCoords(feature);
    const coords = raw.map(([lng, lat]) => ({
      lat: parseFloat(lat).toFixed(6),
      lng: parseFloat(lng).toFixed(6),
    }));
    return _normalizeDisplayCoords(coords);
  }
  return [];
};


  const _featureLengthKm = (feature) => {
  try {
    if (!feature || !feature.geometry) return 0;

    // Detect if coordinates look projected (e.g., UTM meters) vs lon/lat degrees
    const _looksProjected = (x, y) => {
      const ax = Math.abs(Number(x));
      const ay = Math.abs(Number(y));
      // lon/lat should be within ~180/90; projected are usually thousands+
      if (!Number.isFinite(ax) || !Number.isFinite(ay)) return false;
      return ax > 200 || ay > 100;
    };

    const _distKm = (a, b, projected) => {
      const x1 = Number(a[0]), y1 = Number(a[1]);
      const x2 = Number(b[0]), y2 = Number(b[1]);
      if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) return 0;
      if (projected) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const m = Math.sqrt(dx * dx + dy * dy);
        return m / 1000; // meters -> km
      }
      // lon/lat
      return turf.distance(turf.point([x1, y1]), turf.point([x2, y2]), { units: "kilometers" });
    };

    const _lineLenKm = (coords, projected) => {
      if (!Array.isArray(coords) || coords.length < 2) return 0;
      let sum = 0;
      for (let i = 0; i < coords.length - 1; i++) {
        sum += _distKm(coords[i], coords[i + 1], projected);
      }
      return sum;
    };

    const gt = feature.geometry.type;

    if (gt === "LineString") {
      const coords = feature.geometry.coordinates || [];
      const projected = coords[0] ? _looksProjected(coords[0][0], coords[0][1]) : false;
      return _lineLenKm(coords, projected);
    }

    if (gt === "MultiLineString") {
      const lines = feature.geometry.coordinates || [];
      let projected = false;
      try {
        const c0 = lines?.[0]?.[0];
        projected = c0 ? _looksProjected(c0[0], c0[1]) : false;
      } catch (e) {}
      return (lines || []).reduce((acc, ln) => acc + _lineLenKm(ln, projected), 0);
    }

    return 0;
  } catch {
    return 0;
  }
};


  // ✅✅✅ NEW: build segment labels at midpoints for each edge
  const _buildSegmentLabels = (coords, isClosed) => {
    try {
      const c = _normalizeDisplayCoords(coords);
      const edges = _calcEdgeLengths(c, isClosed);
      const labels = [];

      for (let i = 0; i < c.length; i++) {
        const e = edges[i];
        if (!e) continue;

        const a = c[i];
        const b = c[(i + 1) % c.length];
        // for open lines, last is null already, but keep extra guard
        if (!isClosed && i === c.length - 1) continue;

        const midLat = (parseFloat(a.lat) + parseFloat(b.lat)) / 2;
        const midLng = (parseFloat(a.lng) + parseFloat(b.lng)) / 2;

        const kmVal = Number(e.km);
        const kmTxt = Number.isFinite(kmVal) ? kmVal.toFixed(2) : "0.00";

        labels.push({
          id: `seg-${i}`,
          lat: midLat,
          lng: midLng,
          text: `${kmTxt} km`,
        });
      }
      return labels;
    } catch (err) {
      console.warn("_buildSegmentLabels failed:", err);
      return [];
    }
  };

  // ✅✅✅ NEW: divIcon cache for numbered points + segment bubbles
  const iconCacheRef = useRef(new Map());

  // ✅ dark scrollbar for long feature lists (uploaded layer details)
  useEffect(() => {
    try {
      const id = "sobek-dark-scroll-style";
      if (document.getElementById(id)) return;

      const style = document.createElement("style");
      style.id = id;
      style.innerHTML = `
        .sobek-dark-scroll{ scrollbar-width: thin; scrollbar-color: #9a9a9a #111; }
        .sobek-dark-scroll::-webkit-scrollbar{ width:8px; height:8px; }
        .sobek-dark-scroll::-webkit-scrollbar-track{ background:#111; }
        .sobek-dark-scroll::-webkit-scrollbar-thumb{ background:#9a9a9a; border-radius:8px; border:2px solid #111; }
      
        .sobek-hide-line-actions .leaflet-draw-actions{ display:none !important; }
        .sobek-hide-line-actions .leaflet-draw-actions-top{ display:none !important; }
`;
      document.head.appendChild(style);
    } catch (e) {}
  }, []);

  const _getDivIcon = (key, html, iconSize = [26, 26], iconAnchor = [13, 13]) => {
    const cache = iconCacheRef.current;
    if (cache.has(key)) return cache.get(key);
    const icon = L.divIcon({
      className: "",
      html,
      iconSize,
      iconAnchor,
    });
    cache.set(key, icon);
    return icon;
  };

  const getPointNumberIcon = (n) => {
    const key = `pt-${n}`;
    const html = `
      <div style="
        width:24px;height:24px;border-radius:999px;
        background:#1ba99e;color:#fff;
        display:flex;align-items:center;justify-content:center;
        font-weight:700;font-size:12px;
        border:2px solid rgba(255,255,255,0.9);
        box-shadow:0 2px 6px rgba(0,0,0,0.35);
        ">
        ${n}
      </div>
    `;
    return _getDivIcon(key, html, [24, 24], [12, 12]);
  };

  const getSegmentBubbleIcon = (text) => {
    const key = `seg-${text}`;
    const safeText = String(text || "").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const html = `
      <div style="
        padding:4px 8px;
        background:rgba(0,0,0,0.75);
        color:#fff;
        border-radius:10px;
        font-size:12px;
        font-weight:700;
        white-space:nowrap;
        box-shadow:0 2px 8px rgba(0,0,0,0.35);
        border:1px solid rgba(255,255,255,0.2);
      ">
        ${safeText}
      </div>
    `;
    // anchor bottom center so bubble sits "above" the edge
    return _getDivIcon(key, html, [90, 28], [45, 14]);
  };

  // ✅ helper: build polygon Feature from circle layer (approx) + area
  const circleLayerToPolygonFeature = (circleLayer, layerId, source = "draw") => {
    const center = circleLayer.getLatLng();
    const radiusM = circleLayer.getRadius(); // meters
    // turf.circle radius: use meters
    const poly = turf.circle([center.lng, center.lat], radiusM, { steps: 64, units: "meters" });
    poly.properties = {
      ...(poly.properties || {}),
      id: layerId,
      source,
      shapeType: "circle",
      radius_m: radiusM,
      center_lat: center.lat,
      center_lng: center.lng,
    };
    return { polygonFeature: poly, radiusM, center };
  };

  const handleCreated = (e) => {
    setIsDrawingNow(false); // ✅ stop hiding vertices after shape is created
    removePolygonDblClickFinish(); // ✅✅✅ مهم

    // ✅ لو حصل لأي سبب واليوزر قدر يرسم رغم القفل
    if (hasAnyShape) {
      try {
        featureGroupRef.current?.removeLayer?.(e.layer);
      } catch {}
      setCustomAlert("لا يمكن رسم شكل جديد أو رفع ملف قبل حذف الشكل الحالي.");
      return;
    }

    const layer = e.layer;

    // ✅ tag layer source (so we can remove only drawings, not uploads)
    layer.__sobekSource = "draw";

    const layerId = layer._leaflet_id;

    // ✅ رسم شكل واحد فقط: (بالقفل ده أساسًا مفيش تاني) + احتياط لو حصل
    removePreviousDrawnPolygons(layerId);

    // ✅ حالة Circle
    if (layer instanceof L.Circle) {
      const { polygonFeature, radiusM, center } = circleLayerToPolygonFeature(layer, layerId, "draw");
      const areaM2 = Math.PI * radiusM * radiusM;
      const areaKm2 = fmtKm2(areaM2);

      // ✅ خزن: احتفظ فقط بالمرفوع + الشكل المرسوم الحالي
      setShapes((prevShapes) => {
        const uploads = prevShapes.filter((s) => s?.properties?.source === "upload");
        return [...uploads, polygonFeature];
      });

      // coordinates: نعرض مركز الدائرة فقط (علشان منطقياً)
      const coordinates = [{ lat: parseFloat(center.lat).toFixed(6), lng: parseFloat(center.lng).toFixed(6) }];

      setEdgeLengths([]);
      setSegmentLabels([]); // ✅ no segment labels for circle

      setShapeDetails({
        areaM2: areaM2.toFixed(2),
        areaKm2,
        coordinates,
        featureGeoJSON: polygonFeature, // ✅ مهم للتصدير
        shapeType: "circle",
        radiusM: radiusM.toFixed(2),
      });

      setDrawingCoordinates(coordinates);
      setShowPopup(true);
      setPopupOpen(true);
      return;
    }

    // باقي الأشكال (Polygon/Rectangle => Polygon GeoJSON)
    const geojson = layer.toGeoJSON();

    // ✅ حالة Polyline (Line)
    if (geojson?.geometry?.type === "LineString") {
      geojson.properties = {
        ...(geojson.properties || {}),
        id: layerId,
        source: "draw",
        shapeType: "polyline",
      };

      // ✅ خزن: احتفظ فقط بالمرفوع + الشكل المرسوم الحالي
      setShapes((prevShapes) => {
        const uploads = prevShapes.filter((s) => s?.properties?.source === "upload");
        return [...uploads, geojson];
      });

      const coordinates = _featureToDisplayCoords(geojson);
      const edgeL = _calcEdgeLengths(coordinates, false);
      const lenKm = _featureLengthKm(geojson);
      const lenM = lenKm * 1000;

      setEdgeLengths(edgeL);
      setSegmentLabels([]); // ✅ only show segment labels when pressing Measure

      setShapeDetails({
        lengthKm: Number.isFinite(lenKm) ? lenKm.toFixed(4) : "0.0000",
        lengthM: Number.isFinite(lenM) ? lenM.toFixed(2) : "0.00",
        coordinates,
        featureGeoJSON: geojson,
        shapeType: "polyline",
      });

      setDrawingCoordinates(coordinates);
      setShowPopup(true);
      setPopupOpen(true);
      return;
    }

    if (geojson?.geometry?.type === "Polygon" || geojson?.geometry?.type === "MultiPolygon") {
      geojson.properties = {
        ...(geojson.properties || {}),
        id: layerId, // ✅ ثابت للـ edit/delete
        source: "draw", // ✅ للتمييز عن upload
        shapeType: geojson?.geometry?.type === "Polygon" ? "polygon" : "multipolygon",
      };

      // ✅ خزن: احتفظ فقط بالمرفوع + الشكل المرسوم الحالي
      setShapes((prevShapes) => {
        const uploads = prevShapes.filter((s) => s?.properties?.source === "upload");
        return [...uploads, geojson];
      });

      // ✅ استخراج الإحداثيات (Polygon / MultiPolygon)
      const rawCoords =
        geojson.geometry.type === "Polygon"
          ? geojson.geometry.coordinates?.[0] || []
          : geojson.geometry.type === "MultiPolygon"
          ? geojson.geometry.coordinates?.[0]?.[0] || []
          : [];

        // ✅ sanitize polygon ring: remove duplicated closing point + accidental double-click extra point
      const _sameLL = (a, b) => {
        if (!a || !b) return false;
        const dx = Math.abs(Number(a[0]) - Number(b[0]));
        const dy = Math.abs(Number(a[1]) - Number(b[1]));
        return dx < 1e-12 && dy < 1e-12;
      };

      let cleanedRaw = Array.isArray(rawCoords) ? [...rawCoords] : [];

      // remove duplicate closing coordinate if present (last == first)
      if (cleanedRaw.length > 2 && _sameLL(cleanedRaw[0], cleanedRaw[cleanedRaw.length - 1])) {
        cleanedRaw.pop();
      }

      // remove accidental "double-click" extra point (last == prev)
      if (cleanedRaw.length > 2 && _sameLL(cleanedRaw[cleanedRaw.length - 1], cleanedRaw[cleanedRaw.length - 2])) {
        cleanedRaw.pop();
      }

      const coordinates = cleanedRaw.map(([lng, lat]) => ({
        lat: parseFloat(lat).toFixed(6),
        lng: parseFloat(lng).toFixed(6),
      }));

      const areaM2 = turf.area(geojson);
      const areaKm2 = fmtKm2(areaM2);

      setEdgeLengths([]);
      setSegmentLabels([]); // ✅ only show segment labels when pressing Measure

      setShapeDetails({
        areaM2: areaM2.toFixed(2),
        areaKm2,
        coordinates: _normalizeDisplayCoords(coordinates),
        featureGeoJSON: geojson,
        shapeType: "polygon",
      });

      setDrawingCoordinates(_normalizeDisplayCoords(coordinates));
      setShowPopup(true);
      setPopupOpen(true);
    } else {
      setCustomAlert("Only polygons/rectangle/circle are supported.");
    }
  };

  const handleDeleteLastPoint = () => {
    // تحقق من وجود إحداثيات لحذف النقطة الأخيرة
    if (drawingCoordinates.length > 0) {
      const updatedCoordinates = drawingCoordinates.slice(0, drawingCoordinates.length - 1);

      // إذا كانت هناك إحداثيات متبقية بعد الحذف
      if (updatedCoordinates.length > 0) {
        setDrawingCoordinates(updatedCoordinates); // تحديث الإحداثيات

        // ✅ حساب area لو Polygon points (هنا بنستخدم m2 ثم km2)
        const poly = turf.polygon([updatedCoordinates.map((c) => [parseFloat(c.lng), parseFloat(c.lat)])]);
        const areaM2 = turf.area(poly);
        const areaKm2 = fmtKm2(areaM2);

        setShapeDetails((prev) => ({
          ...(prev || {}),
          areaM2: areaM2.toFixed(2),
          areaKm2,
          coordinates: updatedCoordinates,
          featureGeoJSON: poly,
          shapeType: "polygon",
        }));
        setShowPopup(true);
      } else {
        setShapeDetails({ areaM2: "", areaKm2: "", coordinates: [], featureGeoJSON: null });
        setDrawingCoordinates([]);
        setSegmentLabels([]);
        setShowPopup(false); // إخفاء البوب أب
      }
    }
  };

  const handleEdited = (e) => {
    setIsDrawingNow(false);
    removePolygonDblClickFinish(); // ✅✅✅ مهم

    const editedLayers = e.layers;

    setShapes((prevShapes) => {
      const updatedShapes = [...prevShapes];

      // ✅ keep edits stable for uploaded + drawn features (preserve upload metadata)
      const _findShapeIndexByLayerId = (arr, lid) => {
        return (arr || []).findIndex((s) => {
          const p = s?.properties || {};
          const pid = p?.id;
          const plid = p?.leafletId;

          if (Number(plid) === Number(lid)) return true;
          if (pid === lid) return true;
          if (typeof pid === "string" && pid.endsWith(`-${lid}`)) return true;
          return false;
        });
      };

      const _getStableEditedProps = (arr, lid, incomingProps, defaults = {}) => {
        const idx = _findShapeIndexByLayerId(arr, lid);
        const prevProps = idx !== -1 ? (arr[idx]?.properties || {}) : {};
        const merged = { ...prevProps, ...(incomingProps || {}), ...(defaults || {}) };

        const isUpload =
          prevProps?.source === "upload" ||
          incomingProps?.source === "upload" ||
          defaults?.source === "upload" ||
          typeof prevProps?.uploadGroupId !== "undefined";

        merged.source = isUpload ? "upload" : "draw";
        merged.leafletId = Number(lid);

        // keep stable id for uploads (ex: group-123)
        if (!merged.id) {
          merged.id = isUpload ? `${merged.uploadGroupId || "upload"}-${lid}` : lid;
        } else if (isUpload && typeof merged.id !== "string") {
          merged.id = `${merged.uploadGroupId || "upload"}-${lid}`;
        }

        return { idx, props: merged };
      };


      editedLayers.eachLayer((layer) => {
        const layerId = layer?._leaflet_id;

        // ✅ Circle edit
        if (layer instanceof L.Circle) {
          const { polygonFeature, radiusM, center } = circleLayerToPolygonFeature(layer, layerId, "draw");
          const areaM2 = Math.PI * radiusM * radiusM;
          const areaKm2 = fmtKm2(areaM2);

          const index = updatedShapes.findIndex((s) => s?.properties?.id === layerId);
          if (index !== -1) updatedShapes[index] = polygonFeature;
          else updatedShapes.push(polygonFeature);

          const coordinates = [{ lat: parseFloat(center.lat).toFixed(6), lng: parseFloat(center.lng).toFixed(6) }];

          setEdgeLengths([]);
          setEdgeMeasurement(null);
          setSegmentLabels([]); // ✅ no segment labels for circle

          setShapeDetails({
            areaM2: areaM2.toFixed(2),
            areaKm2,
            coordinates,
            featureGeoJSON: polygonFeature,
            shapeType: "circle",
            radiusM: radiusM.toFixed(2),
          });

          setDrawingCoordinates(coordinates);
          setShowPopup(true);
          setPopupOpen(true);
          return;
        }

        // ✅ Polygon/Rectangle edit
        const geojson = layer.toGeoJSON();

        // ✅ Polyline edit
        if (geojson?.geometry?.type === "LineString") {
          const stable = _getStableEditedProps(updatedShapes, layerId, geojson.properties, {
            shapeType: "polyline",
          });

          geojson.properties = stable.props;

          if (stable.idx !== -1) updatedShapes[stable.idx] = geojson;
          else updatedShapes.push(geojson);

          const coordinates = _featureToDisplayCoords(geojson);
          const edgeL = _calcEdgeLengths(coordinates, false);
          const lenKm = _featureLengthKm(geojson);
          const lenM = lenKm * 1000;

          setEdgeLengths(edgeL);
          setEdgeMeasurement(null);
          setSegmentLabels([]); // ✅ show segment labels only when Measure is pressed

          setShapeDetails({
            lengthKm: Number.isFinite(lenKm) ? lenKm.toFixed(4) : "0.0000",
            lengthM: Number.isFinite(lenM) ? lenM.toFixed(2) : "0.00",
            coordinates,
            featureGeoJSON: geojson,
            shapeType: "polyline",
          });

          setDrawingCoordinates(coordinates);
          setShowPopup(true);
          setPopupOpen(true);
          return;
        }

        if (geojson?.geometry?.type === "Polygon" || geojson?.geometry?.type === "MultiPolygon") {
          const stable = _getStableEditedProps(updatedShapes, layerId, geojson.properties, {
            shapeType: "polygon",
          });

          geojson.properties = stable.props;

          if (stable.idx !== -1) updatedShapes[stable.idx] = geojson;
          else updatedShapes.push(geojson);

const latlngs = layer.getLatLngs()?.[0] || [];
          const formattedCoordinates = latlngs.map((latlng) => ({
            lat: parseFloat(latlng.lat).toFixed(6),
            lng: parseFloat(latlng.lng).toFixed(6),
          }));

          const displayCoords = _normalizeDisplayCoords(formattedCoordinates);
          setEdgeLengths([]);
          setEdgeMeasurement(null);
          setSegmentLabels([]); // ✅ show segment labels only when Measure is pressed

          const areaM2 = turf.area(geojson);
          const areaKm2 = fmtKm2(areaM2);

          setShapeDetails({
            areaM2: areaM2.toFixed(2),
            areaKm2,
            coordinates: displayCoords,
            featureGeoJSON: geojson,
            shapeType: "polygon",
          });

          // ✅ keep numbered points visible for ALL polygon features in the same uploaded group (not only edited one)
          try {
            const gId = geojson?.properties?.uploadGroupId;
            if (typeof gId !== "undefined" && gId !== null) {
              const all = [];
              (updatedShapes || []).forEach((sh) => {
                try {
                  const p = sh?.properties || {};
                  const gt = sh?.geometry?.type;
                  if (p?.uploadGroupId !== gId) return;
                  if (gt !== "Polygon" && gt !== "MultiPolygon") return;
                  const c = _featureToDisplayCoords(sh) || [];
                  c.forEach((pt) => all.push(pt));
                } catch (e) {}
              });
              setDrawingCoordinates(all.length ? all : displayCoords);
            } else {
              setDrawingCoordinates(displayCoords);
            }
          } catch (e) {
            setDrawingCoordinates(displayCoords);
          }
          setShowPopup(true);
          setPopupOpen(true);

          const coordsText = formattedCoordinates.map(({ lat, lng }) => `Lat: ${lat}, Lng: ${lng}`).join("<br>");

          const popupTableCell = document.querySelector("td#coordinates-cell");
          if (popupTableCell) {
            popupTableCell.innerHTML = coordsText;
          }
        } else {
          setCustomAlert("Only polygons/rectangle/circle are supported.");
        }
      });

      return updatedShapes;
    });
  };

  // ✅✅✅ NEW: helper to build Uploaded Layers groups
  const _layerGroupKeyFromGeom = (geomType) => {
    if (!geomType) return "other";
    if (geomType === "Point" || geomType === "MultiPoint") return "points";
    if (geomType === "LineString" || geomType === "MultiLineString") return "lines";
    if (geomType === "Polygon" || geomType === "MultiPolygon") return "polygons";
    return "other";
  };

  const _layerGroupTitle = (key) => {
    if (key === "points") return "Points";
    if (key === "lines") return "Lines";
    if (key === "polygons") return "Polygons";
    return "Other";
  };

  // ✅✅✅ NEW: toggle show/hide uploaded layer group without deleting

/*
  const toggleUploadedLayerVisibility = (groupId) => {
    try {
      setUploadedMapLayers((prev) => {
        const next = prev.map((g) => {
          if (g.id !== groupId) return g;

          const nextVisible = !g.visible;

          // apply to map featureGroup
          const fg = featureGroupRef.current;
          if (fg) {
            (g.layerIds || []).forEach((lid) => {
              const layerObj =
              uploadedLayerObjectsRef.current.get(lid) ||
              uploadedLayerObjectsRef.current.get(String(lid)) ||
              uploadedLayerObjectsRef.current.get(Number(lid));
              if (!layerObj) return;
              try {
                if (nextVisible) fg.addLayer(layerObj);
                else fg.removeLayer(layerObj);
              } catch (e) {
                console.warn("toggle layer failed:", e);
              }
            });
          }

          // ✅ IMPORTANT: uploaded layers are rendered from `shapes` state (GeoJSON),
          // so we must also hide/show those features, otherwise checkbox won't affect them.
          try {
            if (!nextVisible) {
              setShapes((prev) => {
                const removed = [];
                const kept = [];
                (prev || []).forEach((f) => {
                  if (f?.properties?.source === "upload" && f?.properties?.uploadGroupId === g.id) removed.push(f);
                  else kept.push(f);
                });
                if (removed.length > 0) hiddenUploadedFeaturesRef.current.set(g.id, removed);
                return kept;
              });
            } else {
              const restore = hiddenUploadedFeaturesRef.current.get(g.id) || [];
              if (restore.length > 0) {
                setShapes((prev) => {
                  const prevIds = new Set((prev || []).map((f) => f?.properties?.id).filter(Boolean));
                  const toAdd = restore.filter((f) => !prevIds.has(f?.properties?.id));
                  return [...(prev || []), ...toAdd];
                });
                hiddenUploadedFeaturesRef.current.delete(g.id);
                // ✅ Fallback: if we don't have cached GeoJSON features for this group,
                // rebuild them from the real Leaflet layers so measurement/panel keep working after hide/show.
                try {
                  const hadCache = restore && restore.length > 0;
                  if (!hadCache) {
                    const rebuilt = [];
                    (g.layerIds || []).forEach((lid2) => {
                      const layerObj2 =
                        uploadedLayerObjectsRef.current.get(lid2) ||
                        uploadedLayerObjectsRef.current.get(String(lid2)) ||
                        uploadedLayerObjectsRef.current.get(Number(lid2));
                      if (!layerObj2) return;
                      if (typeof layerObj2.toGeoJSON !== "function") return;
                      const gj2 = layerObj2.toGeoJSON();
                      if (!gj2) return;

                      const pushFeature = (feat) => {
                        if (!feat || feat.type !== "Feature" || !feat.geometry) return;
                        feat.properties = {
                          ...(feat.properties || {}),
                          source: "upload",
                          uploadGroupId: g.id,
                          uploadGroupKey: g.key || g.typeKey || g.geomType || "upload",
                        };
                        // keep a stable id if missing
                        if (!feat.properties.id) feat.properties.id = `${g.id}-${lid2}`;
                        rebuilt.push(feat);
                      };

                      if (gj2.type === "FeatureCollection" && Array.isArray(gj2.features)) {
                        gj2.features.forEach(pushFeature);
                      } else {
                        pushFeature(gj2);
                      }
                    });

                    if (rebuilt.length > 0) {
                      setShapes((prev2) => {
                        const prevIds2 = new Set((prev2 || []).map((f) => f?.properties?.id).filter(Boolean));
                        const toAdd2 = rebuilt.filter((f) => !prevIds2.has(f?.properties?.id));
                        return [...(prev2 || []), ...toAdd2];
                      });
                    }
                  }
                } catch (e) {}

              }
            }
          } catch (e) {}

          
          // ✅ NOTE: Hiding an uploaded group should NOT clear Current Data state.
          // We keep panel + coordinates in state, and the map markers/segment bubbles are
          // conditionally hidden based on group visibility (see `isCurrentUploadLayerHidden`).
          try {
            // (intentionally no-op)
          } catch (e) {}
return { ...g, visible: nextVisible };
        });

        // clean empty groups (just in case)
        return next.filter((g) => Array.isArray(g.layerIds) && g.layerIds.length > 0);
      });
    } catch (e) {
      console.warn("toggleUploadedLayerVisibility failed:", e);
    }
  };

  // Handle file upload and parsing shapefile
*/

  // ✅ Toggle visibility for an uploaded layer group (by group.id)
  // ✅ Toggle visibility for an uploaded layer group (by group.id)
const toggleUploadedLayerVisibility = (groupId) => {
  setUploadedMapLayers((prev) =>
    prev.map((g) => {
      if (g.id !== groupId) return g;

      const nextVisible = !g.visible;
      const layerIds = Array.isArray(g.layerIds) ? g.layerIds : [];

      // 1) Hide/show Leaflet layers on the map
      layerIds.forEach((lid) => {
        const layerObj =
              uploadedLayerObjectsRef.current.get(lid) ||
              uploadedLayerObjectsRef.current.get(String(lid)) ||
              uploadedLayerObjectsRef.current.get(Number(lid));
        if (!layerObj) return;

        try {
          if (nextVisible) {
            if (featureGroupRef.current && !featureGroupRef.current.hasLayer(layerObj)) {
              featureGroupRef.current.addLayer(layerObj);
            }
            if (mapRef.current && !mapRef.current.hasLayer(layerObj)) {
              layerObj.addTo(mapRef.current);
            }
          } else {
            featureGroupRef.current?.removeLayer(layerObj);
            mapRef.current?.removeLayer(layerObj);
          }
        } catch (e) {}
      });

      // 2) Hide/show uploaded features from `shapes` state (used by Measure/Current Data)
      try {
        if (!nextVisible) {
          setShapes((prevShapes) => {
            const removed = [];
            const kept = [];
            (prevShapes || []).forEach((f) => {
              if (f?.properties?.source === "upload" && f?.properties?.uploadGroupId === g.id) removed.push(f);
              else kept.push(f);
            });
            if (removed.length > 0) hiddenUploadedFeaturesRef.current.set(g.id, removed);
            return kept;
          });
        } else {
          const restore = hiddenUploadedFeaturesRef.current.get(g.id) || [];
          if (restore.length > 0) {
            setShapes((prevShapes) => {
              const prevIds = new Set((prevShapes || []).map((f) => f?.properties?.id).filter(Boolean));
              const toAdd = restore.filter((f) => !prevIds.has(f?.properties?.id));
              return [...(prevShapes || []), ...toAdd];
            });
            hiddenUploadedFeaturesRef.current.delete(g.id);
          }
        }
      } catch (e) {}

      // 3) If the hidden group is currently displayed in "Current Data", clear it
      try {
        if (!nextVisible) {
          const cur = shapeDetails;
          const curProps = cur?.featureGeoJSON?.properties || {};
          const curUploadGroupId = curProps?.uploadGroupId;

          const isCurrentFromThisGroup = curUploadGroupId === g.id;

          const key = g?.key || g?.typeKey;
          const isPointsGroup = key === "points";
          const isLinesGroup = key === "lines";

          const isCurrentUploadedPoints =
            isPointsGroup &&
            (cur?.shapeType === "points" || cur?.featureGeoJSON?.geometry?.type === "MultiPoint") &&
            curProps?.source === "upload";

          const isCurrentUploadedLines =
            isLinesGroup &&
            cur?.shapeType === "polyline" &&
            curProps?.source === "upload";

          const PRESERVE_CURRENT_PANEL_ON_HIDE = true; // ✅ keep panel & numbers when hiding uploaded layers

          if (!PRESERVE_CURRENT_PANEL_ON_HIDE && (isCurrentFromThisGroup || isCurrentUploadedPoints || isCurrentUploadedLines)) {
            setDrawingCoordinates([]);
            setShapeDetails(null);
            setEdgeMeasureMode(false);
            setEdgeMeasurement(null);
            setEdgeLengths([]);
            setSegmentLabels([]);
            setShowPopup(false);
            setPopupOpen(false);
          }
        }
      } catch (e) {}

      return { ...g, visible: nextVisible };
    })
  );
};


  // ✅ Delete an uploaded layer group (trash icon)
  const deleteUploadedLayerGroup = (groupId) => {
    const group = uploadedMapLayers.find((g) => g.id === groupId);
    if (!group) return;

    const layerIds = Array.isArray(group.layerIds) ? group.layerIds : [];

    layerIds.forEach((lid) => {
      const layerObj =
              uploadedLayerObjectsRef.current.get(lid) ||
              uploadedLayerObjectsRef.current.get(String(lid)) ||
              uploadedLayerObjectsRef.current.get(Number(lid));
      if (!layerObj) {
        uploadedLayerObjectsRef.current.delete(lid);
        return;
      }

      try {
        featureGroupRef.current?.removeLayer(layerObj);
      } catch (e) {}

      try {
        mapRef.current?.removeLayer(layerObj);
      } catch (e) {}

      uploadedLayerObjectsRef.current.delete(lid);
    });

    // remove group UI entry
    setUploadedMapLayers((prev) => prev.filter((g) => g.id !== groupId));

    // remove uploaded shapes belonging to this group (feature id prefix is group.id + "-")
    try {
      setShapes((prev) =>
        prev.filter((s) => {
          const sid = s?.properties?.id || s?.id;
          const ug = s?.properties?.uploadGroupId;
          return !(
            ug === groupId ||
            (typeof sid === "string" && sid.startsWith(groupId + "-"))
          );
        })
      );
    } catch (e) {}
  

    // ✅ FIX: لو اللاير المحذوف كان هو اللي ظاهر في Current Data (خصوصاً نقاط الـ upload)
    // لازم نمسح الـ Current Data عشان مايفضلش يعرض نقاط/لاير اتحذف.
    try {
      const currentUploadGroupId = shapeDetails?.featureGeoJSON?.properties?.uploadGroupId;
      const isCurrentFromThisGroup = currentUploadGroupId === groupId;

      // حالة نقاط الـ upload (MultiPoint) ماكانش فيها uploadGroupId، فنعتمد على نوع المجموعة + نوع الـ shape الحالي
      const isCurrentUploadedPoints =
        group?.geomType === "Point" &&
        shapeDetails?.shapeType === "points" &&
        shapeDetails?.featureGeoJSON?.properties?.source === "upload" &&
        shapeDetails?.featureGeoJSON?.geometry?.type === "MultiPoint";

      if (isCurrentFromThisGroup || isCurrentUploadedPoints) {
        setDrawingCoordinates([]);
        setShapeDetails(null);
        setEdgeMeasureMode(false);
        setEdgeMeasurement(null);
        setEdgeLengths([]);
        setSegmentLabels([]);
      }
    } catch (e) {}

    // ✅ بعد حذف لاير (من Share) ارجعي فورًا لـ Details
    setSelectedTab("details");
};


  // ✅ Helpers: احسب تفاصيل كل Uploaded Group (عشان السهم يفتح ويعرض معلوماته)
  const buildFeatureCollectionFromUploadedGroup = useCallback((group) => {
    const features = [];
    try {
      (group?.layerIds || []).forEach((lid) => {
        const lyr = uploadedLayerObjectsRef.current.get(lid);
        if (!lyr) return;
        try {
          const gj = lyr.toGeoJSON();
          if (!gj) return;
          if (gj.type === "Feature") {
            features.push(gj);
          } else if (gj.type === "FeatureCollection" && Array.isArray(gj.features)) {
            features.push(...gj.features);
          }
        } catch (e) {
          // ignore
        }
      });
    } catch (e) {
      // ignore
    }
    return { type: "FeatureCollection", features };
  }, []);

  const getUploadedGroupTotalLengthKm = useCallback((group) => {
    const fc = buildFeatureCollectionFromUploadedGroup(group);
    let sum = 0;
    try {
      (fc.features || []).forEach((f) => {
        const t = f?.geometry?.type;
        if (t === "LineString" || t === "MultiLineString") {
          sum += _featureLengthKm(f);
        }
      });
    } catch (e) {
      // ignore
    }
    return sum;
  }, [buildFeatureCollectionFromUploadedGroup]);

  
  const getUploadedGroupTotalAreaKm2 = useCallback(
    (group) => {
      try {
        const fc = buildFeatureCollectionFromUploadedGroup(group);
        if (!fc || !fc.features || fc.features.length === 0) return 0;
        let totalM2 = 0;
        (fc.features || []).forEach((f) => {
          const t = f?.geometry?.type;
          if (t === "Polygon" || t === "MultiPolygon") {
            try {
              totalM2 += turf.area(f);
            } catch (e) {}
          }
        });
        const km2 = totalM2 / 1000000;
        return Number.isFinite(km2) ? km2 : 0;
      } catch (e) {
        return 0;
      }
    },
    [buildFeatureCollectionFromUploadedGroup]
  );

const getUploadedGroupPointCoords = useCallback((group) => {
    const fc = buildFeatureCollectionFromUploadedGroup(group);
    const coords = [];
    try {
      (fc.features || []).forEach((f) => {
        const t = f?.geometry?.type;
        if (t === "Point") {
          const c = f.geometry.coordinates;
          if (Array.isArray(c) && c.length >= 2) coords.push(c);
        } else if (t === "MultiPoint") {
          const arr = f.geometry.coordinates || [];
          arr.forEach((c) => {
            if (Array.isArray(c) && c.length >= 2) coords.push(c);
          });
        }
      });
    } catch (e) {
      // ignore
    }
    return coords; // [[x,y], ...]
  }, [buildFeatureCollectionFromUploadedGroup]);



  const handleFileUpload = async (event) => {
    // ✅ ممنوع رفع لو فيه شكل موجود
    if (hasAnyShape) {
      setCustomAlert("لا يمكن رفع ملف قبل حذف الشكل الحالي.");
      if (fileInputRef.current) fileInputRef.current.value = null;
      return;
    }

    const file = event.target.files[0];

    if (file) {
      try {
        const reader = new FileReader();

        reader.onload = async (e) => {
          try {
            // const geojson = await shp(e.target.result);
            let geojson = await shp(e.target.result);

            // ✅ normalize shpjs output (sometimes returns {layerName: FeatureCollection, ...})
            if (geojson && !geojson.type && typeof geojson === "object" && !Array.isArray(geojson)) {
              const merged = { type: "FeatureCollection", features: [] };
              Object.values(geojson).forEach((v) => {
                if (!v) return;
                if (v.type === "FeatureCollection" && Array.isArray(v.features)) {
                  merged.features.push(...v.features);
                } else if (v.type === "Feature") {
                  merged.features.push(v);
                }
              });
              geojson = merged;
            }


            // ✅✅✅ Deep-flatten any remaining GeoJSON content so we don't miss any features (lines/points/polygons)
            try {
              const __all = [];
              const __addAny = (obj) => {
                if (!obj) return;
                if (Array.isArray(obj)) {
                  obj.forEach(__addAny);
                  return;
                }
                if (obj && typeof obj === "object") {
                  if (obj.type === "FeatureCollection") {
                    (obj.features || []).forEach(__addAny);
                    return;
                  }
                  if (obj.type === "Feature") {
                    __all.push(obj);
                    return;
                  }
                  if (obj.type && obj.coordinates) {
                    __all.push({ type: "Feature", properties: {}, geometry: obj });
                    return;
                  }
                  Object.values(obj).forEach(__addAny);
                }
              };
              __addAny(geojson);
              if (__all.length > 0) {
                geojson = { type: "FeatureCollection", features: __all };
              }
            } catch (e) {}

const validatedGeoJSON = reformatGeoJSON(geojson);
            // ✅✅✅ explode Multi* geometries to ensure ALL parts are rendered & counted
            const validatedGeoJSONFinal = (() => {
              try {
                const inFc = validatedGeoJSON;
                const out = [];
                (inFc?.features || []).forEach((f) => {
                  const g = f?.geometry;
                  const type = g?.type;
                  const coords = g?.coordinates;
                  const props = f?.properties || {};
                  if (type === "MultiPoint" && Array.isArray(coords)) {
                    coords.forEach((c, i) =>
                      out.push({
                        type: "Feature",
                        properties: { ...props, __partIndex: i + 1 },
                        geometry: { type: "Point", coordinates: c },
                      })
                    );
                  } else if (type === "MultiLineString" && Array.isArray(coords)) {
                    coords.forEach((c, i) =>
                      out.push({
                        type: "Feature",
                        properties: { ...props, __partIndex: i + 1 },
                        geometry: { type: "LineString", coordinates: c },
                      })
                    );
                  } else if (type === "MultiPolygon" && Array.isArray(coords)) {
                    coords.forEach((c, i) =>
                      out.push({
                        type: "Feature",
                        properties: { ...props, __partIndex: i + 1 },
                        geometry: { type: "Polygon", coordinates: c },
                      })
                    );
                  } else {
                    out.push(f);
                  }
                });
                return { type: "FeatureCollection", features: out };
              } catch (e) {
                return validatedGeoJSON;
              }
            })();


            // ✅ نحول الـ FeatureCollection لقائمة Features (كل Feature له id ثابت) — أفضل للـ edit/delete/measure
            const featuresToAdd = [];

            // ✅✅✅ NEW: build groups for the TAB LAYERS (Points/Lines/Polygons)
            const groupsMap = new Map(); // key => group object

            const ensureGroup = (key) => {
              if (groupsMap.has(key)) return groupsMap.get(key);
              const g = {
                id: `upl-${key}`,
                key,
                typeKey: key, // ✅ keep backward-compat for UI conditions
                name: _layerGroupTitle(key),
                displayName: _layerGroupTitle(key),
                visible: true,
                layerIds: [],
              };
              groupsMap.set(key, g);
              return g;
            };

            const uploadedBounds = L.latLngBounds([]);

            L.geoJSON(validatedGeoJSONFinal, {
      // ✅ avoid default marker icons for uploaded points
      pointToLayer: (feature, latlng) => {
        try {
          return L.circleMarker(latlng, { radius: 6, weight: 2, fillOpacity: 0.85 });
        } catch (e) {
          /* return L.marker(latlng); */
                return L.circleMarker(latlng, { radius: 6, color: "#FFD700", fillColor: "#FFD700", fillOpacity: 0.9 });
        }
      },
    }).eachLayer((layer) => {
              // ✅ Ensure uploaded POINTS render as CircleMarker (not Marker icons)
              let _useLayer = layer;
              try {
                const _t = layer?.feature?.geometry?.type;
                if (
                  layer instanceof L.Marker &&
                  (_t === "Point" || _t === "MultiPoint") &&
                  typeof layer.getLatLng === "function"
                ) {
                  const _ll = layer.getLatLng();
                  const _cm = L.circleMarker(_ll, {
                    radius: 7,
                    color: "rgb(27, 169, 158)",
                    weight: 2,
                    fillColor: "rgb(27, 169, 158)",
                    fillOpacity: 0.9,
                  });
                  try {
                    const _p = layer.getPopup && layer.getPopup();
                    if (_p && typeof _p.getContent === "function") {
                      _cm.bindPopup(_p.getContent());
                    }
                  } catch (e) {}
                  _useLayer = _cm;
                }
              } catch (e) {}

              // ✅ collect bounds so we can zoom to the uploaded shapefile
              try {
                if (_useLayer && typeof _useLayer.getBounds === "function") {
                  uploadedBounds.extend(_useLayer.getBounds());
                } else if (_useLayer && typeof _useLayer.getLatLng === "function") {
                  uploadedBounds.extend(_useLayer.getLatLng());
                } else if (layer && typeof layer.getBounds === "function") {
                  uploadedBounds.extend(layer.getBounds());
                } else if (layer && typeof layer.getLatLng === "function") {
                  uploadedBounds.extend(layer.getLatLng());
                }
              } catch (e) {}

              // ✅ tag upload layers (so drawing cleanup doesn't remove them)
              layer.__sobekSource = "upload";

              // أضف للـ FeatureGroup عشان يبقى قابل للـ edit/delete
              featureGroupRef.current?.addLayer(_useLayer);

              // ✅ store layer object to toggle later
              const __uplKey = _useLayer?._leaflet_id || layer._leaflet_id;

              // ✅ store with both numeric & string keys to avoid any type mismatch later
              uploadedLayerObjectsRef.current.set(__uplKey, _useLayer);
              uploadedLayerObjectsRef.current.set(String(__uplKey), _useLayer);

              // خزّن نفس الـ layer كـ GeoJSON Feature مع id
              const f = (_useLayer.toGeoJSON ? _useLayer.toGeoJSON() : layer.toGeoJSON());
              if (
                f?.geometry?.type === "Polygon" ||
                f?.geometry?.type === "MultiPolygon" ||
                f?.geometry?.type === "LineString" ||
                f?.geometry?.type === "MultiLineString" ||
                f?.geometry?.type === "Point" ||
                f?.geometry?.type === "MultiPoint"
              ) {
                // ✅✅✅ add to correct UI layer group
                const key = _layerGroupKeyFromGeom(f.geometry.type);
                const g = ensureGroup(key);
                const __lid = _useLayer?._leaflet_id || layer._leaflet_id;

                // ✅ bind id on the Leaflet layer itself so Leaflet-Draw delete can read it
                try {
                  _useLayer.feature = _useLayer.feature || { type: "Feature", properties: {} };
                  _useLayer.feature.type = "Feature";
                  _useLayer.feature.properties = {
                    ...(_useLayer.feature.properties || {}),
                    id: `${g.id}-${__lid}`,
                    source: "upload",
                    uploadGroupId: g.id,
                    uploadGroupKey: key,
                    leafletId: __lid,
                  };
                  _useLayer.options = _useLayer.options || {};
                  _useLayer.options.id = `${g.id}-${__lid}`;
                  _useLayer.__sobekUploadGroupId = g.id;
                } catch (eBind) {}

                // ✅ important: tie features to their group so delete/measure works correctly
                f.properties = {
                  ...(f.properties || {}),
                  id: `${g.id}-${__lid}`,
                  source: "upload",
                  uploadGroupId: g.id,
                  uploadGroupKey: key,
                  leafletId: __lid,
                };
                featuresToAdd.push(f);

                g.layerIds.push(__lid);
              }
            // ✅ Zoom to uploaded shapefile location (even if it's far from current view)
            try {
              const map = mapRef.current;
              if (map && uploadedBounds && typeof uploadedBounds.isValid === "function" && uploadedBounds.isValid()) {
                map.fitBounds(uploadedBounds, { padding: [40, 40], maxZoom: 11 });
              } else if (uploadedBounds && typeof uploadedBounds.isValid === "function" && uploadedBounds.isValid()) {
                pendingUploadBoundsRef.current = uploadedBounds;
              }
            } catch (e) {}

            });

            if (featuresToAdd.length === 0) {
              setCustomAlert("الملف لا يحتوي على مضلع أو إحداثيات صالحة.");
              return;
            }

            // ✅ قفل: بعد رفع أول ملف، ممنوع رسم/رفع تاني لحد الحذف
            setShapes((prevShapes) => [...prevShapes, ...featuresToAdd]);

            // ✅✅✅ set uploaded groups for tab (sorted stable)
            const groupsArr = Array.from(groupsMap.values()).filter((g) => g.layerIds.length > 0);
            groupsArr.sort((a, b) => {
              const order = { polygons: 1, lines: 2, points: 3, other: 4 };
              return (order[a.key] || 9) - (order[b.key] || 9);
            });
            setUploadedMapLayers((prev) => [...prev, ...groupsArr]);

            // ✅ بعد الرفع افتحي Tab التفاصيل فورًا
            setSelectedTab("details");



            // ✅ بعد الابلود: فعّلي Apply (من غير نقل تلقائي للـ Share)
            setAllowShareTab(true);
            // ✅ تفاصيل أول Feature فقط للـ popup
            const UPDATE_CURRENT_LAYER_FROM_UPLOAD = true;
            const firstFeature = UPDATE_CURRENT_LAYER_FROM_UPLOAD ? featuresToAdd[0] : null;

// ✅ FIX: for uploaded LINES, compute TOTAL length across ALL uploaded line features (not first one)
const allLineFeatures = (featuresToAdd || []).filter(
  (f) => f?.geometry?.type === "LineString" || f?.geometry?.type === "MultiLineString"
);
const totalUploadedLinesKm = allLineFeatures.reduce((acc, f) => {
  try {
    const v = _featureLengthKm(f);
    return acc + (Number.isFinite(v) ? v : 0);
  } catch (e) {
    return acc;
  }
}, 0);

            let areaM2 = 0;

            try {
              // ✅ لو الملف المرفوع LineString => قياس طول فقط
              if (firstFeature?.geometry?.type === "LineString" || firstFeature?.geometry?.type === "MultiLineString") {
                const coordinates = _featureToDisplayCoords(firstFeature);
                const edgeL = _calcEdgeLengths(coordinates, false);
                const lenKm = totalUploadedLinesKm;

                setEdgeLengths(edgeL);
                setSegmentLabels([]); // ✅ show segment labels only when Measure is pressed

                setDrawingCoordinates(coordinates);
                setShapeDetails({
                  coordinates,
                  lengthKm: Number.isFinite(lenKm) ? lenKm.toFixed(4) : "0.0000",
                  lengthM: Number.isFinite(lenKm) ? (lenKm * 1000).toFixed(2) : "0.00",
                  featureGeoJSON: firstFeature,
                  shapeType: "polyline",
                });

                setShowPopup(true);
                setPopupOpen(true);
              } else if (
                firstFeature?.geometry?.type === "Point" ||
                firstFeature?.geometry?.type === "MultiPoint"
              ) {
                // ✅ points: اجمع كل النقاط (بدون عرض نقطة واحدة منفصلة)، وخلّي APPLY يتفعّل
                try {
                  const allPoints = [];
                  (featuresToAdd || []).forEach((ff) => {
                    const gt = ff?.geometry?.type;
                    if (gt === "Point") {
                      const c = ff.geometry.coordinates || [];
                      if (Array.isArray(c) && c.length >= 2) {
                        allPoints.push([c[0], c[1]]);
                      }
                    } else if (gt === "MultiPoint") {
                      const cs = ff.geometry.coordinates || [];
                      (cs || []).forEach((c) => {
                        if (Array.isArray(c) && c.length >= 2) allPoints.push([c[0], c[1]]);
                      });
                    }
                  });

                  const coordsList = (allPoints || []).map((c) => ({
                    // NOTE: UI تعرض X=lng و Y=lat
                    lng: String(c[0]),
                    lat: String(c[1]),
                  }));

                  const pointsGroupId = (() => {
                    try {
                      const arr = Array.from(groupsMap.values());
                      const pg = arr.find((gg) => gg?.key === "points" || gg?.geomType === "Point");
                      return pg?.id || null;
                    } catch (e) {
                      return null;
                    }
                  })();

                  const multiPointFeature = {
                    type: "Feature",
                    properties: { source: "upload", shapeType: "points", uploadGroupId: pointsGroupId, id: pointsGroupId ? `${pointsGroupId}-multipoint` : "upl-multipoint" },
                    geometry: { type: "MultiPoint", coordinates: allPoints },
                  };

                  setEdgeLengths([]);
                  setSegmentLabels([]);
                  setDrawingCoordinates(coordsList);
                  setShapeDetails({
                    featureGeoJSON: multiPointFeature,
                    coordinates: coordsList,
                    areaKm2: "",
                    areaM2: "",
                    shapeType: "points",
                  });
                } catch (e) {
                  setEdgeLengths([]);
                  setSegmentLabels([]);
                  setDrawingCoordinates([]);
                  setShapeDetails(null);
                }

                setShowPopup(true);
                setPopupOpen(true);
              } else {
                // ✅ FIX: total area + numbering for ALL polygons in the upload (not first polygon only)
                const __allPolyUpload = (featuresToAdd || []).filter(
                  (ff) => ff?.geometry?.type === "Polygon" || ff?.geometry?.type === "MultiPolygon"
                );

                const __totalAreaM2 = (__allPolyUpload || []).reduce((sum, ff) => {
                  try {
                    return sum + turf.area(ff);
                  } catch (e) {
                    return sum;
                  }
                }, 0);

                areaM2 = __totalAreaM2;
                const areaKm2 = fmtKm2(__totalAreaM2);

                // ✅ coordinates for ALL polygons so numbering appears on all of them
                let coordinates = [];
                try {
                  coordinates = (__allPolyUpload || [])
                    .flatMap((ff) => _featureToDisplayCoords(ff) || [])
                    .filter(
                      (c) =>
                        c &&
                        Number.isFinite(parseFloat(c.lat)) &&
                        Number.isFinite(parseFloat(c.lng))
                    );
                } catch (e) {
                  coordinates = [];
                }

                // fallback: first polygon ring only (old behavior)
                if (!Array.isArray(coordinates) || coordinates.length === 0) {
                  const rawCoords =
                    firstFeature.geometry.type === "Polygon"
                      ? firstFeature.geometry.coordinates?.[0] || []
                      : firstFeature.geometry.type === "MultiPolygon"
                      ? firstFeature.geometry.coordinates?.[0]?.[0] || []
                      : [];

                  coordinates = _normalizeDisplayCoords(
                    rawCoords.map(([lng, lat]) => ({
                      lat: parseFloat(lat).toFixed(6),
                      lng: parseFloat(lng).toFixed(6),
                    }))
                  );
                }

                setEdgeLengths([]);
                setSegmentLabels([]); // ✅ show segment labels only when Measure is pressed

                setDrawingCoordinates(coordinates);
                setShapeDetails({
                  coordinates,
                  areaM2: __totalAreaM2 > 0 ? __totalAreaM2.toFixed(2) : "0.00",
                  areaKm2,
                  featureGeoJSON: firstFeature,
                  shapeType: "polygon",
                });

                setShowPopup(true);
                setPopupOpen(true);
              }
            } catch (err) {
              console.error("خطأ أثناء حساب المساحة أو تنسيق الإحداثيات:", err);
              setCustomAlert("تعذر استخراج التفاصيل من الشكل.");
            }


            // ✅ fallback: ensure APPLY stays enabled after upload
            setShapeDetails((prev) =>
              prev || {
                featureGeoJSON: { type: "FeatureCollection", features: featuresToAdd },
                coordinates: [],
                shapeType: "upload",
              }
            );
            setCustomAlert("File uploaded successfully and displayed on the map!");
          } catch (error) {
            console.error("Error processing Shapefile:", error);
            setCustomAlert("Invalid or unsupported Shapefile format.");
          }
          fileInputRef.current.value = null;
        };

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error("File upload failed:", error);
        setCustomAlert("Failed to upload file. Please try again.");
      }
    } else {
      setCustomAlert("No file selected.");
    }
  };

  
  const handleMeasure = () => {

    // ✅ Collect shapes from state OR from Leaflet FeatureGroup (uploaded/drawn)
    let __allShapes = Array.isArray(shapes) ? shapes.slice() : [];

    // If state is empty (common after hide/show), rebuild from real layers
    if (__allShapes.length === 0) {
      try {
        const fg = featureGroupRef.current;
        if (fg && typeof fg.toGeoJSON === "function") {
          const gj = fg.toGeoJSON();
          if (gj) {
            if (gj.type === "FeatureCollection" && Array.isArray(gj.features)) __allShapes = gj.features.slice();
            else if (gj.type === "Feature") __allShapes = [gj];
          }
        }
      } catch (e) {}
    }

    // Filter out hidden uploaded groups (if feature is tagged with uploadGroupId)
    try {
      if (Array.isArray(uploadedMapLayers) && uploadedMapLayers.length > 0) {
        const vis = new Map(uploadedMapLayers.map((g) => [g.id, g.visible !== false]));
        __allShapes = (__allShapes || []).filter((f) => {
          const gid = f?.properties?.uploadGroupId;
          if (!gid) return true;
          return vis.get(gid) !== false;
        });
      }
    } catch (e) {}

    if (!Array.isArray(__allShapes) || __allShapes.length === 0) {
      setCustomAlert("No shapes drawn or uploaded!");
      return;
    }
try {
      const features = __allShapes.filter((f) => f && f.type === "Feature" && f.geometry);

      if (features.length === 0) {
        setCustomAlert("No valid shapes found to measure.");
        return;
      }

      const lineFeatures = features.filter((f) => f.geometry?.type === "LineString" || f.geometry?.type === "MultiLineString");
      const polyFeatures = features.filter(
        (f) => f.geometry?.type === "Polygon" || f.geometry?.type === "MultiPolygon"
      );

      // ✅ 1) Polyline measurement (no area)
      if (polyFeatures.length === 0 && lineFeatures.length > 0) {
        const first = lineFeatures[0];
        const coordinates = _featureToDisplayCoords(first);
        const edgeL = _calcEdgeLengths(coordinates, false);

        const totalLenKm = lineFeatures.reduce((sum, f) => {
          const v = _featureLengthKm(f);
          return sum + (Number.isFinite(v) ? v : 0);
        }, 0);

        setEdgeLengths(edgeL);

        setShapeDetails({
          lengthKm: Number.isFinite(totalLenKm) ? totalLenKm.toFixed(2) : "0.0000",
          lengthM: Number.isFinite(totalLenKm) ? (totalLenKm * 1000).toFixed(2) : "0.00",
          coordinates,
          featureGeoJSON: first,
          shapeType: "polyline",
        });

        // ✅✅✅ FIX: show segment bubbles for EACH edge (no total bubble)
        try {
          const __allLineSegLabels = [];
          (lineFeatures || []).forEach((lf, lIdx) => {
            try {
              const c = _featureToDisplayCoords(lf);
              const lbs = _buildSegmentLabels(c, false) || [];
              (lbs || []).forEach((lb, i) => {
                __allLineSegLabels.push({ ...lb, id: `seg-l${lIdx}-${i}` });
              });
            } catch (e) {}
          });
          setSegmentLabels(__allLineSegLabels);
        } catch (e) {
          setSegmentLabels([]);
        }

        setDrawingCoordinates(coordinates);
        setShowPopup(true);
        setPopupOpen(true);
        return;
      }

      // ✅ 2) Polygon / MultiPolygon (Area + edge lengths)
      if (polyFeatures.length > 0) {
        // Circle special-case (we store circle as polygon feature with properties)
        const first = polyFeatures[0];
        const isCircle = first?.properties?.shapeType === "circle";
        const radiusM =
          first?.properties?.radius_m != null
            ? Number(first.properties.radius_m)
            : first?.properties?.radiusM != null
            ? Number(first.properties.radiusM)
            : null;

        // Total area across all polygon features
        const totalAreaM2 = polyFeatures.reduce((sum, f) => {
          try {
            return sum + turf.area(f);
          } catch {
            return sum;
          }
        }, 0);

        const areaKm2 = fmtKm2(totalAreaM2);

        if (isCircle && Number.isFinite(radiusM)) {
          const centerLat =
            first?.properties?.center_lat != null ? Number(first.properties.center_lat) : null;
          const centerLng =
            first?.properties?.center_lng != null ? Number(first.properties.center_lng) : null;

          const coordinates =
            Number.isFinite(centerLat) && Number.isFinite(centerLng)
              ? [{ lat: centerLat.toFixed(6), lng: centerLng.toFixed(6) }]
              : _featureToDisplayCoords(first);

          setEdgeLengths([]);
          setSegmentLabels([]); // ✅ circle => no segments

          setShapeDetails({
            areaM2: totalAreaM2 > 0 ? totalAreaM2.toFixed(2) : "0.00",
            areaKm2,
            coordinates,
            featureGeoJSON: first,
            shapeType: "circle",
            radiusM: Number.isFinite(radiusM) ? radiusM.toFixed(2) : undefined,
          });

          setDrawingCoordinates(coordinates);
          setShowPopup(true);
          setPopupOpen(true);
          return;
        }

        const coordinates = _featureToDisplayCoords(first);
        const edgeL = _calcEdgeLengths(coordinates, true);

        setEdgeLengths(edgeL);

        setShapeDetails({
          areaM2: totalAreaM2 > 0 ? totalAreaM2.toFixed(2) : "0.00",
          areaKm2,
          coordinates,
          featureGeoJSON: first,
          shapeType: "polygon",
        });

        // ✅✅✅ FIX: show segment bubbles + numbering for ALL polygons (not first polygon only)
        const __allPolyCoords = (polyFeatures || [])
          .flatMap((pf) => _featureToDisplayCoords(pf) || [])
          .filter((c) => c && Number.isFinite(parseFloat(c.lat)) && Number.isFinite(parseFloat(c.lng)));

        const __allPolySegLabels = [];
        (polyFeatures || []).forEach((pf, pIdx) => {
          try {
            const c = _featureToDisplayCoords(pf);
            const lbs = _buildSegmentLabels(c, true) || [];
            lbs.forEach((lb, i) => {
              __allPolySegLabels.push({ ...lb, id: `seg-p${pIdx}-${i}` });
            });
          } catch (e) {}
        });

        setSegmentLabels(__allPolySegLabels);

        // ✅ show numbering on all polygons (markers are driven by drawingCoordinates)
        setDrawingCoordinates(__allPolyCoords.length ? __allPolyCoords : coordinates);
        setShowPopup(true);
        setPopupOpen(true);
        return;
      }

      setCustomAlert("Only polygons/rectangle/circle/line are supported.");
    } catch (error) {
      console.error("Error calculating areas/lengths:", error);
      setCustomAlert("An error occurred while measuring. Please try again.");
    }
  };

  // ✅✅✅ NEW: Measure button TOGGLE (press مرة يقيس ويظهر، مرة تانية يخفي القياس)
  const handleMeasureClick = () => {
    const isShown =
      (Array.isArray(segmentLabels) && segmentLabels.length > 0) ||
      !!edgeMeasurement ||
      !!edgeMeasureMode;

    if (isShown) {
      setSegmentLabels([]);
      setEdgeMeasurement(null);
      setEdgeMeasureMode(false);
      return;
    }

    // otherwise measure normally
    handleMeasure();

    const features = Array.isArray(shapes)
      ? shapes.filter((f) => f && f.type === "Feature" && f.geometry)
      : [];

    const hasPoly = features.some(
      (f) => f.geometry?.type === "Polygon" || f.geometry?.type === "MultiPolygon"
    );
    const hasLine = features.some(
      (f) => f.geometry?.type === "LineString" || f.geometry?.type === "MultiLineString"
    );

    // ✅ keep edge-measure mode ON for:
    // 1) a SINGLE LineString (drawn line) -> enables clicking edges to show each segment length
    // 2) a Circle -> show radius line (center → perimeter)
    const __lineFeatures = features.filter(
      (f) => f.geometry?.type === "LineString" || f.geometry?.type === "MultiLineString"
    );
    const __isCircle = shapeDetails?.shapeType === "circle";

    if (__isCircle) {
      setEdgeMeasureMode(true);
    } else if (hasLine && !hasPoly && __lineFeatures.length === 1 && __lineFeatures[0].geometry?.type === "LineString") {
      setEdgeMeasureMode(true);
    } else {
      setEdgeMeasureMode(false);
    }
  };

  // ✅ Circle radius line when Measurement is ON
  useEffect(() => {
    try {
      if (!edgeMeasureMode || shapeDetails?.shapeType !== "circle") {
        setCircleMeasureLine(null);
        setCircleRadiusLabel(null);
        return;
      }

      const rM = parseFloat(
        shapeDetails?.radiusM ?? shapeDetails?.featureGeoJSON?.properties?.radius_m ?? 0
      );

      const centerLat = parseFloat(
        shapeDetails?.featureGeoJSON?.properties?.center_lat ??
          shapeDetails?.coordinates?.[0]?.lat ??
          shapeDetails?.center?.lat ??
          0
      );
      const centerLng = parseFloat(
        shapeDetails?.featureGeoJSON?.properties?.center_lng ??
          shapeDetails?.coordinates?.[0]?.lng ??
          shapeDetails?.center?.lng ??
          0
      );

      if (!rM || !centerLat || !centerLng) {
        setCircleMeasureLine(null);
        setCircleRadiusLabel(null);
        return;
      }

      const km = rM / 1000;
      const dest = turf.destination([centerLng, centerLat], km, 90, {
        units: "kilometers",
      });
      const [dlng, dlat] = dest.geometry.coordinates;

      setCircleMeasureLine([
        [centerLat, centerLng],
        [dlat, dlng],
      ]);

      const midLat = (centerLat + dlat) / 2;
      const midLng = (centerLng + dlng) / 2;
      setCircleRadiusLabel({
        lat: midLat,
        lng: midLng,
        text: `${Math.round(rM)} m`,
      });
    } catch (err) {
      console.warn("circle radius line failed:", err);
      setCircleMeasureLine(null);
      setCircleRadiusLabel(null);
    }
  }, [edgeMeasureMode, shapeDetails]);


  const reformatGeoJSON = (geojson) => {
    if (geojson.type === "FeatureCollection" && Array.isArray(geojson.features)) {
      geojson.features.forEach((feature) => {
        if (
          feature.type === "Feature" &&
          feature.geometry &&
          feature.geometry.type === "Polygon" &&
          Array.isArray(feature.geometry.coordinates)
        ) {
          feature.geometry.coordinates = feature.geometry.coordinates.map((ring) => {
            if (ring[0] !== ring[ring.length - 1]) {
              ring.push(ring[0]); // Close the polygon ring
            }
            return ring;
          });
        }
      });
    }
    return geojson;
  };

  const getCoordinatesString = (coordinates) => {
    if (Array.isArray(coordinates)) {
      return coordinates
        .map((coord, i) => `${i + 1}) Lat: ${coord.lat}, Lng: ${coord.lng}`)
        .join("; ");
    } else {
      return `Lat: ${coordinates.lat}, Lng: ${coordinates.lng}`;
    }
  };

  const _nearestSegmentMeasurement = (latlng) => {
    try {
      const clickPt = turf.point([latlng.lng, latlng.lat]);
      let best = null;

      const considerLine = (coords) => {
        if (!Array.isArray(coords) || coords.length < 2) return;
        const line = turf.lineString(coords);
        const snapped = turf.nearestPointOnLine(line, clickPt, { units: "kilometers" });

        const distKm =
          typeof snapped?.properties?.dist === "number"
            ? snapped.properties.dist
            : Number.POSITIVE_INFINITY;
        const idx = typeof snapped?.properties?.index === "number" ? snapped.properties.index : -1;
        const lineCoords = line.geometry.coordinates;

        if (idx < 0 || idx >= lineCoords.length - 1) return;

        const a = lineCoords[idx];
        const b = lineCoords[idx + 1];
        const segKm = turf.distance(turf.point(a), turf.point(b), { units: "kilometers" });

        if (!best || distKm < best.distKm) {
          best = { distKm, segKm, a, b };
        }
      };

      const __featuresForEdge = (() => {
        try {
          const visibleIds = new Set();
          (uploadedMapLayers || []).forEach((g) => {
            if (g?.visible) (g.layerIds || []).forEach((id) => visibleIds.add(id));
          });

          const all = Array.isArray(shapes) ? shapes : [];
          return all.filter((f) => {
            if (!f?.geometry) return false;
            if (f?.properties?.source === "upload") {
              let lid = f?.properties?.leafletId;
              if (lid == null && typeof f?.properties?.id === "string") {
                const mm = f.properties.id.match(/-(\d+)$/);
                if (mm && mm[1]) lid = Number(mm[1]);
              }
              if (typeof lid === "string") lid = Number(lid);
              return visibleIds.has(lid);
            }
            return true;
          });
        } catch {
          return Array.isArray(shapes) ? shapes : [];
        }
      })();

      (__featuresForEdge || []).forEach((f) => {
        if (!f?.geometry) return;

        const t = f.geometry.type;
        const coords = f.geometry.coordinates;

        // ✅ lines
        if (t === "LineString") {
          considerLine(coords || []);
          return;
        }
        if (t === "MultiLineString") {
          (coords || []).forEach((line) => considerLine(line || []));
          return;
        }

        // ✅ polygons: measure nearest edge by treating each ring as a line
        if (t === "Polygon") {
          (coords || []).forEach((ring) => considerLine(ring || []));
          return;
        }
        if (t === "MultiPolygon") {
          (coords || []).forEach((poly) => {
            (poly || []).forEach((ring) => considerLine(ring || []));
          });
          return;
        }
      });

      // ✅ threshold: لازم يكون قريب من ضلع (50 متر)
      if (!best || !Number.isFinite(best.distKm) || best.distKm > 0.05) return null;

      const lengthKm = best.segKm || 0;
      const lengthM = lengthKm * 1000;

      return {
        lengthKm: Number.isFinite(lengthKm) ? lengthKm.toFixed(4) : "0.0000",
        lengthM: Number.isFinite(lengthM) ? lengthM.toFixed(2) : "0.00",
        from: { lat: Number(best.a[1]).toFixed(6), lng: Number(best.a[0]).toFixed(6) },
        to: { lat: Number(best.b[1]).toFixed(6), lng: Number(best.b[0]).toFixed(6) },
      };
    } catch (err) {
      console.warn("nearest segment measurement failed:", err);
      return null;
    }
  };

  const handleDeleted = (e) => {
    setIsDrawingNow(false);
    removePolygonDblClickFinish(); // ✅✅✅ مهم

    // ✅✅✅ Guard: في بعض الحالات Leaflet-Draw بيبعت e أو e.layers = null
    if (!e || !e.layers || typeof e.layers.eachLayer !== "function") {
      return;
    }

    const idsToRemove = new Set();

    e.layers.eachLayer((layer) => {
      const rawId = layer?.feature?.properties?.id ?? layer?.options?.id ?? layer?._leaflet_id;
      if (rawId !== undefined && rawId !== null) {
        idsToRemove.add(rawId);
        // ✅ لو id كان بصيغة "groupId-123" ضيف كمان الـ numeric id علشان يتشال من layerIds و ref map
        if (typeof rawId === "string") {
          const mm = rawId.match(/-(\d+)$/);
          if (mm && mm[1]) idsToRemove.add(Number(mm[1]));
        }
      }
    });

    // ✅✅✅ FIX: لو Leaflet-Draw رجّع لنا _leaflet_id رقم فقط، احنا مخزّنين upload features كـ "groupId-<id>"
    try {
      const numericIds = Array.from(idsToRemove).filter(
        (v) => typeof v === "number" && Number.isFinite(v)
      );
      if (numericIds.length) {
        (uploadedMapLayers || []).forEach((g) => {
          numericIds.forEach((nid) => idsToRemove.add(`${g.id}-${nid}`));
        });
      }
    } catch (e2) {
      /* ignore */
    }

    setShapes((prevShapes) => prevShapes.filter((s) => !idsToRemove.has(s?.properties?.id)));

    // ✅✅✅ NEW: update uploadedMapLayers + ref map
    setUploadedMapLayers((prev) =>
      (prev || [])
        .map((g) => ({
          ...g,
          layerIds: (g.layerIds || []).filter((id) => !idsToRemove.has(id)),
        }))
        .filter((g) => (g.layerIds || []).length > 0)
    );
    idsToRemove.forEach((id) => uploadedLayerObjectsRef.current.delete(id));

    setDrawingCoordinates([]);
    setShapeDetails(null);
    setEdgeMeasureMode(false);
    setEdgeMeasurement(null);
    setEdgeLengths([]);
    setSegmentLabels([]);

    // ✅ (useEffect على shapes هيرجع يفتح الرسم/الرفع لو مفيش shapes)
  
    // ✅ لو انتي في Share Tab و عملتي Delete ارجعي فورًا لـ Details
    if (selectedTab === "share") {
      setSelectedTab("details");
    }

    // ✅ ضمان الرجوع لـ Details حتى لو selectedTab stale داخل الـ handler
    setSelectedTab("details");
};

  useEffect(() => {
    const interval = setInterval(() => {
      const el = document.querySelector(".leaflet-control-layers");
      if (el) {
        el.style.display = "block";
        el.style.opacity = "1";
        el.style.zIndex = "9999";
        el.style.pointerEvents = "auto";
        clearInterval(interval);
      }
    }, 500);
  }, []);

  const handleMapCreated = (map) => {
    console.log("✅ Map instance created!", map);
    mapRef.current = map;
    setMapInstance(map);
    setIsMapReady(true);
  };

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    const onDblClickFinishPolygon = (ev) => {
      try {
        // ✅✅✅ لو DOM listener شغال، سيبه هو اللي يتحكم (أقوى)
        if (polygonDblListenerRef.current) return;

        const h = getDrawControl()?._toolbars?.draw?._modes?.polygon?.handler;

        // ✅ شغال فقط لو polygon draw mode enabled
        if (h && typeof h.enabled === "function" && h.enabled()) {
          // ✅ امنع dblclick zoom أثناء الرسم
          if (ev?.originalEvent) {
            L.DomEvent.preventDefault(ev.originalEvent);
            L.DomEvent.stopPropagation(ev.originalEvent);
          }

          // ✅ أنهِ الشكل فورًا بدون الرجوع لأول نقطة
          if (typeof h._finishShape === "function") h._finishShape();
          else if (typeof h.completeShape === "function") h.completeShape();
        }
      } catch (e) {
        console.warn("Finish polygon on dblclick failed:", e);
      }
    };

    map.on("dblclick", onDblClickFinishPolygon);
    return () => map.off("dblclick", onDblClickFinishPolygon);
    // الأفضل ربطها بـ mapInstance أو isMapReady
  }, [mapInstance]);

  // ✅✅✅ Polyline limited to 2 points via Leaflet.Draw option (maxPoints: 2)
// (removed old auto-finish draw:drawvertex listener to avoid Leaflet.Draw internal errors)


  useEffect(() => {
    if (!mapRef.current) {
      console.log("⚠️ MapContainer not mounted yet");
      const timer = setInterval(() => {
        if (mapRef.current) {
          console.log("✅ MapContainer mounted after delay");
          clearInterval(timer);
        }
      }, 1000);

      return () => clearInterval(timer);
    }
  }, []);

  // fire when all tiles are loaded
  function MapLoadListener() {
    useMapEvents({
      load: () => {
        console.log("🎉 Map load event fired — ready!");
        setIsMapReady(true);
      },
    });
    return null;
  }

  // ✅ Edge measurement: when Measure tool is active, clicking on any edge shows its length
  function EdgeMeasureListener() {
    useMapEvents({
      click: (e) => {
        if (!edgeMeasureMode) return;

        // لازم يكون فيه تفاصيل/أشكال
        if (!shapeDetails && (!Array.isArray(shapes) || shapes.length === 0)) return;

        const result = _nearestSegmentMeasurement(e.latlng);
        if (!result) {
          setCustomAlert("اضغطي قريب من ضلع/حافة الشكل لعرض طول الضلع.");
          return;
        }

        setEdgeMeasurement(result);
        // ✅ افتحي التابه لو كانت مقفولة
        setShowPopup(true);
        setPopupOpen(true);
        /* setSelectedTab("details"); */
      if (selectedTab !== "share") setSelectedTab("details");
      },
    });
    return null;
  }

  // فور تعريف mapCenter و mapRef:
  useEffect(() => {
    if (mapRef.current && mapCenter) {
      // zoom مناسب يمكنك تغييره
      mapRef.current.flyTo(mapCenter, 5);
    }
  }, [mapCenter]);

  // =======================
  // ✅✅✅ Visible summary based on visible uploaded layers (no change to draw tools)
  // =======================
  const visibleUploadIds = new Set();
  (uploadedMapLayers || []).forEach((g) => {
    if (g?.visible) (g.layerIds || []).forEach((id) => visibleUploadIds.add(id));
  });

  const visibleFeatures = (Array.isArray(shapes) ? shapes : []).filter((f) => {
    if (!f?.geometry) return false;
    if (f?.properties?.source === "upload") {
      // upload features store numeric leafletId; fallback parse from string id "group-123"
      let lid = f?.properties?.leafletId;
      if (lid == null && typeof f?.properties?.id === "string") {
        const mm = f.properties.id.match(/-(\d+)$/);
        if (mm && mm[1]) lid = Number(mm[1]);
      }
      if (typeof lid === "string") lid = Number(lid);
      return visibleUploadIds.has(lid);
    }
    return true; // drawn is always visible
  });

  const visiblePolyFeatures = visibleFeatures.filter(
    (f) => f.geometry?.type === "Polygon" || f.geometry?.type === "MultiPolygon"
  );
  const visibleLineFeatures = visibleFeatures.filter((f) => f.geometry?.type === "LineString");
  const visiblePointFeatures = visibleFeatures.filter(
    (f) => f.geometry?.type === "Point" || f.geometry?.type === "MultiPoint"
  );

  const visibleType =
    visiblePolyFeatures.length > 0
      ? "polygon"
      : visibleLineFeatures.length > 0
      ? "line"
      : visiblePointFeatures.length > 0
      ? "points"
      : "none";

  const visibleAreaM2 = visiblePolyFeatures.reduce((sum, f) => {
    try {
      return sum + turf.area(f);
    } catch {
      return sum;
    }
  }, 0);

  const visibleTotalLenKm = visibleLineFeatures.reduce((sum, f) => {
    const v = _featureLengthKm(f);
    return sum + (Number.isFinite(v) ? v : 0);
  }, 0);

  const visiblePointCoords = (() => {
    const out = [];
    visiblePointFeatures.forEach((f) => {
      if (f.geometry.type === "Point") {
        const [lng, lat] = f.geometry.coordinates || [];
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          out.push({ lat: Number(lat).toFixed(6), lng: Number(lng).toFixed(6) });
        }
      } else {
        const raw = f.geometry.coordinates || [];
        raw.forEach(([lng, lat]) => {
          if (Number.isFinite(lat) && Number.isFinite(lng)) {
            out.push({ lat: Number(lat).toFixed(6), lng: Number(lng).toFixed(6) });
          }
        });
      }
    });
    return out;
  })();

  // ✅✅✅ NEW: visible circle radius (only if the visible polygon is a circle feature)
  const visibleCircleRadiusM = (() => {
    try {
      const circleF = (visiblePolyFeatures || []).find(
        (f) =>
          f?.properties?.shapeType === "circle" &&
          (f?.properties?.radius_m != null || f?.properties?.radiusM != null)
      );
      if (!circleF) return null;
      const r = circleF.properties.radius_m ?? circleF.properties.radiusM;
      const nr = Number(r);
      return Number.isFinite(nr) ? nr.toFixed(2) : null;
    } catch {
      return null;
    }
  })();

  // ✅✅✅ title rules: upload => Current Layer, draw => Current Data
  const hasUploadData =
    (Array.isArray(uploadedMapLayers) && uploadedMapLayers.length > 0) ||
    (Array.isArray(shapes) && shapes.some((s) => s?.properties?.source === "upload"));
  const hasDrawData = Array.isArray(shapes) && shapes.some((s) => s?.properties?.source === "draw");
  const detailsTitle = hasUploadData ? "Current Geospatial Layer" : "Current Data";

  // =======================
  // (باقي الكود كما هو بدون تغيير)
  // =======================

  const handleDownload = async () => {
    console.log("Starting download process (viewport capture A3)…");

    const map = mapRef.current;

    if (!isMapReady) {
      setCustomAlert("Map is not ready yet. Please wait a few seconds and try again.");
      return;
    }

    if (!shapeDetails) {
      setCustomAlert("No shape details or coordinates available.");
      return;
    }

    // ✅ 1) تجهيز GeoJSON + النصوص
    // لو عندنا featureGeoJSON (مهم خصوصًا للدائرة)
    const featureForExport = shapeDetails.featureGeoJSON;

    if (!featureForExport || !featureForExport.geometry) {
      setCustomAlert("No valid geometry to export.");
      return;
    }

    // polygonCoordinates من geometry مباشرة
    let polygonCoordinates = [];
    try {
      if (featureForExport.geometry.type === "Polygon") {
        polygonCoordinates = featureForExport.geometry.coordinates?.[0] || [];
      } else if (featureForExport.geometry.type === "MultiPolygon") {
        polygonCoordinates = featureForExport.geometry.coordinates?.[0]?.[0] || [];
      } else {
        setCustomAlert("Unsupported geometry for export.");
        return;
      }
    } catch (err) {
      setCustomAlert("Failed to prepare export coordinates.");
      return;
    }

    // تأكد من إغلاق المضلع
    if (polygonCoordinates.length > 1) {
      const [fx, fy] = polygonCoordinates[0];
      const [lx, ly] = polygonCoordinates[polygonCoordinates.length - 1];
      if (fx !== lx || fy !== ly) polygonCoordinates.push([fx, fy]);
    }

    // ✅ رقم الإحداثيات في التقرير
   const coordinatesString =
  (shapeDetails.coordinates || [])
    .map(({ lat, lng }, i) => `<div class="coord-row">${i + 1}) Lat: ${lat}, Lng: ${lng}</div>`)
    .join("") || "—";

    // ✅ لو الطبقة المرفوعة Polygons وفيها أكتر من Feature: اعرض مساحات الـ Polygons بدل Coordinates
    const polygonAreasString = (() => {
      try {
        const gId = shapeDetails?.featureGeoJSON?.properties?.uploadGroupId;
        const isUpload = shapeDetails?.featureGeoJSON?.properties?.source === "upload";
        if (!isUpload || !gId) return "";

        const group = (uploadedMapLayers || []).find((g) => g.id === gId);
        if (!group) return "";

        const fc = buildFeatureCollectionFromUploadedGroup(group);
        const polys = (fc?.features || []).filter(
          (f) => f?.geometry?.type === "Polygon" || f?.geometry?.type === "MultiPolygon"
        );
        if (!polys.length) return "";

        return polys
          .map((f, idx) => {
            let km2 = 0;
            try {
              km2 = turf.area(f) / 1000000;
            } catch (e) {
              km2 = 0;
            }
            return `Polygon${idx + 1}: ${Number.isFinite(km2) ? km2.toFixed(4) : "0.0000"} km²`;
          })
          .join("<br>");
      } catch (e) {
        return "";
      }
    })();

    // خلفية التقرير (لو الصورة في public/)
    const TEMPLATE_URL = new URL("/earth scan.jpeg", window.location.origin).href;
    const SIGNATURE_URL = new URL("/signature.png", window.location.origin).href;

    // ✅ 2) نافذة التقرير: عمودين على مستوى الشاشة
    const newWindow = window.open("", "_blank");
    newWindow.document.write(`
    <html>
      <head>
        <title>EarthScan® – Report</title>
        <meta charset="utf-8"/>
        <style>
  html, body { height:100%; margin:0; }

  /* شاشة من عمودين: يسار = صفحة A4 مبسوطة بالكامل، يمين = سكرين */
  #viewport{
    height:100vh;
    display:grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    padding:12px;
    box-sizing:border-box;
    background:#f5f7f8;
  }

  /* لا سكرول داخل العمود الشمال */
  #left-pane{
    height:100%;
    overflow:hidden;
    display:flex; justify-content:center; align-items:center;
    position:relative;
  }

  /* غلاف ثابت بمقاس A4 (نستخدمه للـscale) */
  #page-scale-wrap{
    width:794px;
    height:1123px;
    transform-origin: top left;
    position:absolute;
  }

  /* صفحة A4 الفعلية */
  #pdf-page{
    width:100%; height:100%;
    position:relative;
    background:#fff;
    -webkit-print-color-adjust: exact; print-color-adjust: exact;
    box-shadow: 0 0 0 1px rgba(0,0,0,0.08);
    border-radius: 2mm;
    overflow:hidden;
      color:#588880;          /* ✅ نفس اللون الأصلي */

  }

  /* الخلفية */
  #pdf-bg{
    position:absolute; inset:0;
    background-image:url('${TEMPLATE_URL}');
    background-repeat:no-repeat; background-position:center top; background-size:cover;
    z-index:0;
    border-radius: 2mm;
  }

  .white-overlay{
    position:absolute; left:10mm; right:10mm; top:45mm; bottom:28mm;
    background:#ffffff; border-radius:2mm; z-index:1; display:none;
  }

  /* ✅ العنوان سطرين */
  .header-block{
  position:absolute; z-index:2;
  top:40mm;              /* ✅ نزلناه لتحت عشان مايدخلش في اللي فوق */
  left:20mm; right:20mm;
  /* font-weight:600; */       /* ✅ بدل bold عشان اللون مايبانش أغمق */
  color:#588880;          /* ✅ نفس اللون الأصلي */
  font-size:12pt; line-height:1.4;
  display:flex; flex-direction:column; gap:2mm;
}


  /* محتوى التقرير (بدون سكرول) */
  .content{
    position:absolute; z-index:2;
    left:20mm; right:20mm; top:55mm; bottom:30mm;
    overflow:hidden;
  }
  .left{ font-size:12.5pt; line-height:1.65; color:#1a1a1a; }
  .left b{ color:#000; }
 .coords{
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  font-size:10.5pt; line-height:1.45; background:#f7f7f7; border:1px solid #ddd; border-radius:3mm;
  padding:4mm; max-height:60mm;
  overflow:hidden;              /* ✅ no scrollbar */
  column-count:2;               /* ✅ split into 2 columns */
  column-gap:8mm;               /* ✅ spacing between columns */
}

.coord-row{
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
}


  /* يمين الشاشة: السCREENSHOT خارج الصفحة */
  #right-pane{ display:flex; flex-direction:column; gap:8px; min-width:280px; }

  .signature{
    width:65mm;
    height:auto;
    display:block;
    margin:2mm 0 3mm 0;
  }

  .screenshot-title{ font-weight:bold; text-align:center; margin:0; }
  .screenshot-container{
    flex:1; width:100%; background:#eee; border:1px solid #ccc; border-radius:12px;
    display:flex; align-items:center; justify-content:center; overflow:hidden;
  }
  .screenshot-container img{
    width:100%; height:auto; object-fit:contain; display:block;
  }
</style>

      </head>
      <body>
        <div id="viewport">
          <!-- يسار: صفحة التقرير فقط -->
          <div id="left-pane">
            <div id="page-scale-wrap">
              <div id="pdf-page">
                <div id="pdf-bg"></div>
                <div class="white-overlay"></div>
                <div class="header-block">
                  <div>SOBEK Global · SAT Department</div>
                  <div>[${new Date().toLocaleDateString()}]</div>
                </div>

                <div class="content">
                  <div class="left">
                    <div style="font-weight:bold; margin-bottom:6mm; text-decoration:underline;">
                      Subject: Metadata for Download Your Area of Interest – EarthScan Platform
                    </div>

                    Dear User,<br><br>
                    Thank you for using SOBEK Global's - EarthScan platform.<br><br>
                    Kindly find below the metadata for your Area of Interest (AOI), ready for your GIS use.
                    <br><br>

                    <b>Area:</b> ${shapeDetails.areaKm2 || "0.0000"} km²<br>
                    <b>Cloud Average:</b> ${cloudAverage}%<br>
                    <b>Resolution:</b> ${
                      resolution < 100 ? `${resolution} cm` : `${(resolution / 100).toFixed(1)} m`
                    }<br>
                    <b>Nadir Angle:</b> ${nadirAngle}<br>
                    ${
                      polygonAreasString
                        ? `<b>Polygons Areas:</b>
                    <div class="coords">
                      ${polygonAreasString}
                    </div>`
                        : `<b>Coordinates:</b>
                    <div class="coords">
                      ${coordinatesString}
                    </div>`
                    }
                    <br>
                    Sincerely,<br><br>
                    Dr. Mohammed Adel Abdelmajeed<br>                     <img class="signature" src="${SIGNATURE_URL}" alt="Signature" /><br>

                    Founder – CEO<br>
                    SOBEK Global
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- يمين الشاشة: السCREENSHOT خارج الصفحة -->
          <div id="right-pane">
            <h3 class="screenshot-title">Screenshot</h3>
            <div class="screenshot-container" id="drawing">Loading…</div>
          </div>
        </div>

        <!-- سكربت لتكبير/تصغير الورقة تلقائيًا لملء العمود الشمال بدون سكرول -->
        <script>
          (function () {
            function fitPage() {
              var pane = document.getElementById('left-pane');
              var wrap = document.getElementById('page-scale-wrap');
              if (!pane || !wrap) return;

              var W = 794, H = 1123;
              var scale = Math.min(
                pane.clientWidth / W,
                pane.clientHeight / H
              );

              wrap.style.transform = 'scale(' + scale + ')';

              var scaledW = W * scale, scaledH = H * scale;
              wrap.style.left = Math.max(0, (pane.clientWidth - scaledW) / 2) + 'px';
              wrap.style.top  = Math.max(0, (pane.clientHeight - scaledH) / 2) + 'px';
            }

            window.addEventListener('resize', fitPage);
            window.addEventListener('load', fitPage);
            setTimeout(fitPage, 0);
          })();
        </script>
      </body>
    </html>
  `);
    newWindow.document.close();

    try {
      // ✅ 3) لقطة الخريطة من داخل تطبيقك (#capture-wrapper)
      const originalCenter = map.getCenter();
      const originalZoom = map.getZoom();

      const wrapper = document.getElementById("capture-wrapper");
      if (!wrapper) {
        setCustomAlert("لم أتمكن من إيجاد العنصر لالتقاطه.");
        return;
      }

      const canvas = await html2canvas(wrapper, {
        useCORS: true,
        allowTaint: true,
        scale: 4,
      });

      // ارجاع الخريطة لوضعها
      map.setView(originalCenter, originalZoom);

const imgData = canvas.toDataURL("image/png", 1.0);
      const imageElement = newWindow.document.getElementById("drawing");
      if (imageElement) {
        imageElement.innerHTML = "";
        const img = newWindow.document.createElement("img");
        img.src = imgData;
        // ✅ تكبير اللقطة بدون زوم/قصّ — نفس النسبة
        img.style.width = "100%";
        img.style.height = "auto";
        img.style.objectFit = "contain";
        imageElement.appendChild(img);
      }

      // ✅ 4) انتظري رندر الـDOM الجديد ثم جهّزي PDF من صفحتين (A4 + A4) بدون ضغط/Stretch
      await newWindow.Promise?.resolve() ?? null; // احتياطي
      await new Promise((r) => setTimeout(r, 600));

      const reportEl =
        newWindow.document.getElementById("pdf-page") ||
        newWindow.document.getElementById("left-pane") ||
        newWindow.document.body;

      const screenshotEl =
        newWindow.document.getElementById("right-pane") ||
        newWindow.document.getElementById("drawing") ||
        newWindow.document.body;

// ✅ Fix: avoid preview "zoom in/out" flicker by capturing a 1:1 OFFSCREEN clone (no transform changes)
const _reportSourceEl =
  newWindow.document.getElementById("pdf-page") || reportEl;

const _offscreenHost = newWindow.document.createElement("div");
_offscreenHost.style.position = "fixed";
_offscreenHost.style.left = "-10000px";
_offscreenHost.style.top = "0px";
_offscreenHost.style.width = "794px";   // A4-ish in px used by the report layout
_offscreenHost.style.height = "1123px";
_offscreenHost.style.background = "#ffffff";
_offscreenHost.style.pointerEvents = "none";
_offscreenHost.style.zIndex = "-1";

const _reportClone = _reportSourceEl.cloneNode(true);
// ensure no inherited scaling from wrappers
_reportClone.style.transform = "none";
_reportClone.style.position = "relative";
_reportClone.style.left = "0px";
_reportClone.style.top = "0px";

_offscreenHost.appendChild(_reportClone);
newWindow.document.body.appendChild(_offscreenHost);

// give the browser a tick to layout the clone
await new Promise((r) => setTimeout(r, 30));

const reportCanvas = await html2canvas(_reportClone, {
  useCORS: true,
  allowTaint: true,
  backgroundColor: "#ffffff",
  scale: 3,
});
const reportImg = reportCanvas.toDataURL("image/png");

// cleanup
try {
  newWindow.document.body.removeChild(_offscreenHost);
} catch (_) {}


      const screenshotCanvas = await html2canvas(screenshotEl, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        scale: 3,
      });
      const screenshotImg = screenshotCanvas.toDataURL("image/png");

      // ✅ 5) PDF صفحتين A4 (بدون Stretch): الصفحة الأولى = التقرير، الثانية = Screenshot
      const pdf = new jsPDF("p", "mm", "a4");
      const pw = pdf.internal.pageSize.getWidth();
      const ph = pdf.internal.pageSize.getHeight();

      const _addImageFitA4 = (imgData, canvasW, canvasH) => {
        // نحافظ على النسبة ونوسّط الصورة داخل الصفحة
        const r = canvasW && canvasH ? canvasW / canvasH : 1;
        let w = pw;
        let h = w / r;
        if (h > ph) {
          h = ph;
          w = h * r;
        }
        const x = (pw - w) / 2;
        const y = (ph - h) / 2;
        pdf.addImage(imgData, "PNG", x, y, w, h);
      };

      _addImageFitA4(reportImg, reportCanvas.width, reportCanvas.height);
      pdf.addPage();
      _addImageFitA4(screenshotImg, screenshotCanvas.width, screenshotCanvas.height);

      // ✅ 6) تجهيز ملفات الـZIP
      const geojson = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: { type: "Polygon", coordinates: [polygonCoordinates] },
            properties: {
              AREA_KM2: `${shapeDetails.areaKm2 || "0.0000"}`,
              AREA_M2: `${shapeDetails.areaM2 || "0.00"}`,
              Cloud_Avg: `${cloudAverage}%`,
              Resolution: resolution < 100 ? `${resolution} cm` : `${(resolution / 100).toFixed(1)} m`,
              Nadir_Angle: `${nadirAngle}`,
              Notes: `${notes || ""}`,
            },
          },
        ],
      };

      const pdfBlob = pdf.output("blob");
      const pdfArrayBuffer = await pdfBlob.arrayBuffer();
      const shpBlob = new Blob([JSON.stringify(geojson, null, 2)], { type: "application/json" });

      const zip = new JSZip();
      zip.file("metadata_report.pdf", pdfArrayBuffer); // PDF A3 Landscape
      zip.file("geojson.json", JSON.stringify(geojson, null, 2));
      zip.file("shapefile.json", shpBlob); // Placeholder/بديل بسيط لـSHP

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "E-scan preview V.01.zip");
      setCustomAlert("ZIP file downloaded successfully!");
    } catch (error) {
      console.error("Error in download process:", error);
      setCustomAlert("An error occurred during download. Please try again.");
    }
  };

  const handleSendEmail = async () => {
    const isLoggedIn = !!localStorage.getItem("authToken"); // أو حسب نظام التحقق عندك

    // ✅ تحقق من تسجيل الدخول
    if (!isLoggedIn) {
      setCustomAlert("Please log in first to send email.");
      window.location.href = `https://sobekglobal.com/login/?redirect_to=${encodeURIComponent(window.location.href)}`;
      return;
    }

    // ✅ تحقق من وجود بيانات الشكل
    if (!shapeDetails) {
      setCustomAlert("Shape details are missing. Please measure or upload a shape first.");
      return;
    }

    try {
      const formData = new FormData();

      // ✅ رفع الملفات إذا وُجدت
      if (uploadedLayers && uploadedLayers.length > 0) {
        uploadedLayers.forEach((file) => {
          formData.append("files", file);
        });
      }

      // ✅ إضافة باقي البيانات
      formData.append("to", email);
      formData.append("resolution", resolution.toString());
      formData.append("cloudAverage", cloudAverage.toString());
      formData.append("nadirAngle", nadirAngle);
      formData.append("satelliteDEM", selectedOption);
      formData.append("notes", notes || "No notes provided.");
      formData.append("areaKm2", shapeDetails.areaKm2 || "");
      formData.append("areaM2", shapeDetails.areaM2 || "");
      formData.append("coordinates", JSON.stringify(shapeDetails.coordinates || []));
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);

      console.log("FormData being sent:", Array.from(formData.entries()));

      const response = await fetch("http://localhost:5000/send-email", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setCustomAlert("Email sent successfully!");
        setShowSharePopup(false);
        setShowPopup(false);
      } else {
        const errorMessage = await response.text();
        console.error("Failed to send email:", errorMessage);
        setCustomAlert(`Failed to send email: ${errorMessage}`);
      }
    } catch (error) {
      console.error("Error while sending email:", error);
      setCustomAlert("An error occurred while sending the email. Please try again.");
    }
  };

  // دالة لتحويل base64 string إلى Blob
  function base64ToBlob(base64, mimeType = "application/zip") {
    const byteChars = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteChars.length; offset += 512) {
      const slice = byteChars.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, { type: mimeType });
  }


// ✅ Build one FeatureCollection for export (all drawn + all uploaded, including hidden groups)
const _buildExportFeatureCollection = () => {
  const collected = [];
  const pushFeature = (feat) => {
    try {
      if (!feat) return;
      if (feat.type === "FeatureCollection" && Array.isArray(feat.features)) {
        feat.features.forEach(pushFeature);
        return;
      }
      if (feat.type !== "Feature") return;
      if (!feat.geometry || !feat.geometry.type) return;
      collected.push(feat);
    } catch (e) {}
  };

  try {
    (shapes || []).forEach(pushFeature);
  } catch (e) {}

  // include hidden uploaded features so export always includes everything uploaded
  try {
    const m = hiddenUploadedFeaturesRef?.current;
    if (m && typeof m.forEach === "function") {
      m.forEach((arr) => {
        (arr || []).forEach(pushFeature);
      });
    }
  } catch (e) {}

  // de-dup by stable id when possible
  const seen = new Set();
  const out = [];
  (collected || []).forEach((f, idx) => {
    const key =
      (f?.properties?.id && String(f.properties.id)) ||
      (f?.properties?.leafletId && `leaflet-${String(f.properties.leafletId)}`) ||
      `idx-${idx}-${String(f?.geometry?.type || "")}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push(f);
  });

  return { type: "FeatureCollection", features: out };
};

  
const handleSaveAsSHP = () => {
    const geojsonData = _buildExportFeatureCollection();

    if (!geojsonData || !Array.isArray(geojsonData.features) || geojsonData.features.length === 0) {
      setCustomAlert("⚠️ Please draw/upload a shape first!");
      return;
    }

    try {
      // ✅ Export ALL features (drawn + uploaded) into one ZIP containing point/line/polygon shapefiles
      const base64Zip = shpwrite.zip(geojsonData, {
        folder: "E-scan",
        types: { point: "points", line: "lines", polygon: "polygons" },
      });

      if (typeof base64Zip !== "string") {
        setCustomAlert("❌ فشل إنشاء الملف. نوع غير متوقع.");
        return;
      }

      const zipBlob = base64ToBlob(base64Zip);

      const url = URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "E-scan shp V.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

      setCustomAlert("✅ تم حفظ ملف SHP بنجاح باسم E-scan shp V.zip!");
    } catch (error) {
      console.error("❌ خطأ أثناء تنفيذ الحفظ:", error);
      setCustomAlert("❌ فشل حفظ SHP! تحقق من الكونسول.");
    }
  };

  // تحويل البيانات إلى KMZ وحفظها
  
const handleSaveAsKMZ = () => {
    const geoJson = _buildExportFeatureCollection();

    if (!geoJson || !Array.isArray(geoJson.features) || geoJson.features.length === 0) {
      setCustomAlert("No shape drawn to save!");
      return;
    }

    let version = parseInt(localStorage.getItem("kmz_version" || "1"));
    const versionStr = version.toString().padStart(2, "0");
    const filename = `E-scan kmz V.${versionStr}.kmz`;

    const kml = tokml(geoJson);
    const zip = new JSZip();
    zip.file("E-scan.kml", kml);

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, filename);
    });

    localStorage.setItem("kmz_version", (version + 1).toString());
    setCustomAlert("KMZ file saved successfully!");
  };

  const buttonStyle = {
    width: "32px",
    height: "32px",
    backgroundColor: "#fff",
    border: "1px solid #d9d9d9",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const iconStyle = {
    width: "20px",
    height: "20px",
  };

  const onMapCreated = (map) => {
    console.log("✅ Map created");
    mapRef.current = map;
  };
  console.log("rania is map ready", isMapReady);
  // Alias to keep existing UI conditions without introducing new state
  const isMeasureOn = edgeMeasureMode;


  return (
    <div
      id="capture-wrapper" // هنا تعريف ID الأساسي
      style={{ height: "100vh", width: "100vw", position: "relative", overflow: "visible" }}
    >
      {showWelcomeMessage && (
        <>
          {/* ✅ طبقة شفافة تغطي الموقع كله وتمنع التفاعل */}
          <div
            className="sobek-welcome-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.2)", // ظل خفيف
              zIndex: 99998,
              pointerEvents: "auto", // تمنع التفاعل مع ما تحتها
            }}
          ></div>

          {/* ✅ الرسالة نفسها */}
          <div
            className="sobek-welcome-modal"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              padding: "30px",
              maxWidth: "600px",
              zIndex: 99999,
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
              borderRadius: "10px",
              fontFamily: "Arial",
              textAlign: "justify",
              textJustify: "inter-word",
              fontSize: "14px",
              lineHeight: "1.8",
              hyphens: "auto",
              wordBreak: "break-word",
            }}
          >
            <h2 style={{ color: "#1ba99e" }}>Welcome to EarthScan® Digital Geospatial Platform</h2>
            <p>
              We’re excited to have you onboard! EarthScan® is a powerful digital geospatial platform
              that provides accurate, up-to-date satellite imagery and geospatial intelligence.
            </p>
            <p>
              Whether you're exploring areas of interest, downloading metadata (Shapefile, KML, or KMZ)
              for free, or conducting advanced spatial analysis, our platform is designed to order
              Very-High resolution imagery VHR, Digital Elevation Models, Digital Terrain Models,
              Multispectral imagery and more to discover.
            </p>
            <p>Thank you for choosing EarthScan®. Let's unlock the power of Earth observation — together.</p>
            <p>
              <strong>Sign up</strong> for a free Image EarthScan® to save your searches, orders and more.
            </p>
            <p style={{ fontSize: "12px", color: "#666" }}>
              Powered by{" "}
              <a
                href="https://sobekglobal.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#DAA520",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                SOBEK® Global
              </a>{" "}
              | Capture the World: From Space
            </p>

            {/* ✅ الزر داخل ديف في المنتصف فقط */}
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                onClick={() => setShowWelcomeMessage(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#1ba99e",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        </>
      )}

      <div className="sobek-header-wrap">
      <Header
        popupOpen={popupOpen}
        openPopupFully={openPopupFully}
        setMapCenter={setMapCenter}
        setMarkerPosition={setMarkerPosition}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      </div>

      <style>
        {`/* ✅ إزالة السكرولينج نهائياً وإزالة الشريط الأبيض */
      html, body, #root {
        height: 100%;
        width: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
        background: #2c2c2c;
      }

      /* ✅ تحريك أزرار التكبير والتصغير */
      .leaflet-control-zoom {
        top: 120px !important;
      }

      /* ✅ تحريك شريط أدوات القياس والتحرير */
      .leaflet-top.leaflet-right {
        top: 150px !important;
      }

      /* ✅ تحريك أزرار التحميل أو القياس إذا كانت داخل div مستقل */
      .custom-toolbar {
        top: 150px !important;
      }

      /* ✅✅✅ Mobile: منع تداخل الـ Custom Toolbar مع أدوات Leaflet-Draw بدون تغيير الـ structure */
      @media (max-width: 768px), (pointer: coarse), (hover: none) {
        /* خلي زرار الرفع/القياس فوق، وامنع translateY اللي بيزقّه لتحت */
        .custom-toolbar.sobek-toolbar {
          top: 60px !important;
          transform: translateY(0px) !important;
        }

        /* ✅ Mobile: خلي Zoom In/Out زي الديسكتوب (يمين) بدون ما يأثر على الديسكتوب */
        .leaflet-top.leaflet-left {
          left: auto !important;
          right: 12px !important;
        }

        /* ✅ ثبت مكان الزوم تحت الهيدر */
        .leaflet-control-zoom {
          top: 120px !important;
        }

        /* ✅ نزّل شريط أدوات الرسم/التحرير تحت الزوم شوية، وبنفس الترتيب */
        .leaflet-top.leaflet-right {
          top: 220px !important;
        }
      }


        /* نزّل أدوات الرسم شوية لتحت عشان ما تدخلش في بعض */
        .leaflet-top.leaflet-right {
          top: 175px !important;
        }
      }

      @media (max-width: 420px), (max-device-width: 420px) {
        .custom-toolbar.sobek-toolbar {
          top: 56px !important;
        }
        .leaflet-top.leaflet-right {
          top: 170px !important;
        }
      }

      }

      /* ✅✅✅ Responsive Header Fix (Mobile) - keep layout intact on desktop */
        /* Force Sobek Header component (wrapped) to stack on mobile */
        .sobek-header-wrap { width: 100% !important; }
        .sobek-header-wrap > *{
          width: 100% !important;
          display: flex !important;
          flex-wrap: wrap !important;
          align-items: center !important;
          gap: 8px !important;
          padding: 6px 10px !important;
          box-sizing: border-box !important;
          min-width: 0 !important;
        }
        .sobek-header-wrap > * > *{ min-width: 0 !important; }
        .sobek-header-wrap input,
        .sobek-header-wrap [role="searchbox"],
        .sobek-header-wrap textarea,
        .sobek-header-wrap select{
          flex: 1 1 100% !important;
          width: 100% !important;
          max-width: 100% !important;
          margin-top: 6px !important;
        }
        .sobek-header-wrap form,
        .sobek-header-wrap [class*="search"],
        .sobek-header-wrap [id*="search"]{
          flex: 1 1 100% !important;
          width: 100% !important;
        }

      @media (max-width: 560px), (max-device-width: 560px), (pointer: coarse) {
        /* Make header wrap safely without changing desktop layout */
        header, .header {
          display: flex !important;
          flex-wrap: wrap !important;
          align-items: center !important;
          justify-content: flex-start !important;
          gap: 8px !important;
          padding: 8px 10px !important;
          height: auto !important;
          min-height: 48px !important;
          width: 100% !important;
          max-width: 100% !important;
          overflow: visible !important;
        }

        /* Prevent overlap/clipping */
        header *, .header * { box-sizing: border-box !important; min-width: 0 !important; }

        /* Keep icons/buttons compact */
        header button, .header button,
        header a, .header a {
          white-space: nowrap !important;
          flex: 0 0 auto !important;
          max-width: 100% !important;
        }

        header button, .header button {
          padding: 6px 10px !important;
          font-size: 12px !important;
          line-height: 1.15 !important;
        }

        /* Logos/icons shrink a bit */
        header img, .header img,
        header svg, .header svg {
          max-height: 24px !important;
          height: auto !important;
          width: auto !important;
          flex: 0 0 auto !important;
        }

        /* 🔥 Critical: force Search input/box to a NEW LINE full-width */
        header input, .header input,
        header select, .header select,
        header [role="searchbox"], .header [role="searchbox"],
        header [placeholder*="Search"], .header [placeholder*="Search"] {
          flex: 1 1 100% !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          order: 999 !important;
          margin-top: 4px !important;
        }
      }

        /* Prevent overlap/clipping */
        header *, .header * { box-sizing: border-box !important; }

        /* Make text/buttons fit */
        header button, .header button,
        header a, .header a {
          white-space: nowrap !important;
          max-width: 100% !important;
        }

        header button, .header button {
          padding: 6px 10px !important;
          font-size: 12px !important;
          line-height: 1.1 !important;
        }

        /* Logos/icons shrink a bit */
        header img, .header img {
          max-height: 24px !important;
          height: auto !important;
          width: auto !important;
        }

        /* Search/input doesn't push buttons خارج الهيدر */
        header input, .header input,
        header select, .header select {
          flex: 1 1 160px !important;
          min-width: 160px !important;
          max-width: 100% !important;
        }
      }

      /* ✅✅✅ إخفاء زر/أزرار Save الخاصة بالـ Delete فقط */
      .leaflet-draw-remove .leaflet-draw-actions li:first-child{
        display: none !important;
      }

      /* احتياطي: اخفاء أي لينك عنوانه فيه Save */
      .leaflet-draw-remove .leaflet-draw-actions a[title*="Save"],
      .leaflet-draw-remove .leaflet-draw-actions a[title*="save"]{
        display: none !important;
      }

      /* ✅✅✅ أثناء الرسم فقط: اخفاء مربعات/vertex markers الخاصة بـ Leaflet-Draw (عشان يفضل رقم النقطة بس) */
      .sobek-drawing-hide-vertices .leaflet-marker-icon.leaflet-div-icon.leaflet-editing-icon{
        display: none !important;
      }

      /* ============================================================
         ✅✅✅ RESPONSIVE ADDITIONS (Mobile / Tablet) - WITHOUT REMOVING ANYTHING
         ============================================================ */

      /* Side panel + toolbar responsive */
      .sobek-toolbar { z-index: 9999; }

      /* Make map always fill viewport */
      #capture-wrapper, .leaflet-container { max-width: 100vw; max-height: 100vh; }

      

      /* ============================================================
         ✅✅✅ MOBILE FULLSCREEN OVERRIDES (Fix "zoomed-out centered card" issue)
         Works even if the browser uses a desktop viewport width.
         ============================================================ */
      @media (hover: none) and (pointer: coarse) {
        html, body { width: 100% !important; height: 100% !important; margin: 0 !important; padding: 0 !important; }
        body { overflow: hidden !important; display: block !important; }

        /* Kill any centering / max-width wrappers from external CSS */
        #root, #root > * {
          width: 100vw !important;
          height: 100vh !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          background: transparent !important;
        }

        /* Make Leaflet truly full-bleed */
        .leaflet-container {
          width: 100vw !important;
          height: 100vh !important;
          border-radius: 0 !important;
        }

        /* Prevent any accidental scaling */
        #root, body { transform: none !important; zoom: 1 !important; }
      }
/* Tablet */
      @media (max-width: 1024px) {
        .leaflet-control-zoom { top: 105px !important; }
        .leaflet-top.leaflet-right { top: 130px !important; }
      }

      /* Mobile */
      @media (max-width: 768px), (pointer: coarse), (hover: none) {
        /* ✅ Mobile full-bleed map (override any external max-width/margins) */
        html, body, #root {
          width: 100% !important;
          height: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        /* NOTE: there are TWO elements with id="capture-wrapper" in this file (outer wrapper + MapContainer).
           These overrides intentionally cover both without changing structure. */
        #capture-wrapper {
          width: 100vw !important;
          height: 100svh !important; /* better than 100vh on mobile */
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 0 !important;
          max-width: 100vw !important;
          max-height: 100svh !important;
        }

        /* Force Leaflet map to fill the screen and remove any "card" look from external CSS */
        .leaflet-container {
          width: 100vw !important;
          height: 100svh !important;
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          max-width: 100vw !important;
          max-height: 100svh !important;
        }

        /* Welcome modal fit */
        .sobek-welcome-modal{
          width: calc(100vw - 28px) !important;
          max-width: calc(100vw - 28px) !important;
          padding: 18px !important;
          border-radius: 12px !important;
          font-size: 13px !important;
          line-height: 1.6 !important;
        }

        /* ✅ Keep desktop-like symmetry on mobile (no bottom-sheet layout) */
        .sobek-sidepanel{
          width: min(360px, 44vw) !important;
          min-width: 280px !important;
          left: 0 !important;
          right: auto !important;
          top: 70px !important;
          bottom: auto !important;
          height: calc(100vh - 70px) !important;
          max-height: calc(100vh - 70px) !important;
          border-right: 2px solid #444 !important;
          border-top: none !important;
          box-shadow: 2px 0 6px rgba(0,0,0,0.30) !important;
          overflow-y: auto !important;
          padding: 14px !important;
        }

        /* Map stays full viewport behind the side panel (same as desktop) */
        .leaflet-container { height: 100vh !important; width: 100vw !important; }

        /* Toolbar keeps the same corner as desktop */
        .sobek-toolbar{
          top: 120px !important;
          right: 12px !important;
          bottom: auto !important;
          transform: translateY(0px) !important;
        }

        .sobek-toolbar button{
          width: 34px !important;
          height: 34px !important;
        }

        .sobek-toolbar img{
          width: 20px !important;
          height: 20px !important;
        }
      }

      /* Small mobile */
      @media (max-width: 420px), (max-device-width: 420px) {
        .sobek-sidepanel{
          width: 68vw !important;
          min-width: 240px !important;
        }
        .sobek-toolbar{
          top: 110px !important;
          right: 10px !important;
          bottom: auto !important;
        }
        .sobek-toolbar button{
          width: 32px !important;
          height: 32px !important;
        }
      }

      /* ============================================================
         ✅✅✅ HARD MOBILE FULLSCREEN ENFORCEMENT
         Some mobile browsers/emulators still render the app as a centered "card"
         due to centering/max-width wrappers outside the Leaflet container.
         This block forces the map to cover the entire viewport on touch devices
         WITHOUT changing the React structure.
         ============================================================ */
      @media (hover: none) and (pointer: coarse) {
        /* Remove any centering/max-width on top-level wrappers */
        html, body, #root {
          width: 100vw !important;
          height: 100vh !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden !important;
        }

        #root > * {
          width: 100vw !important;
          height: 100vh !important;
          margin: 0 !important;
          padding: 0 !important;
          max-width: none !important;
        }

        #root > * > * {
          width: 100vw !important;
          height: 100vh !important;
          margin: 0 !important;
          padding: 0 !important;
          max-width: none !important;
        }

        /* Force Leaflet map wrapper to be full-bleed */
        #capture-wrapper,
        .leaflet-container {
          position: fixed !important;
          inset: 0 !important;
          width: 100vw !important;
          height: 100vh !important;
          max-width: 100vw !important;
          max-height: 100vh !important;
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          background: transparent !important;
        }

        /* Avoid clipping from any accidental rounded parent */
        .leaflet-pane,
        .leaflet-map-pane,
        .leaflet-control-container {
          border-radius: 0 !important;
        }

        /* Keep header/toolbar above the fixed map */
        .custom-toolbar,
        .sobek-toolbar,
        .header,
        header {
          z-index: 999999 !important;
        }
      }
`}
      </style>

      {/* ✅ Toolbar */}
      <div
        className="custom-toolbar sobek-toolbar"
        style={{
          position: "absolute",
          right: "12px",
          top: "50px",
          zIndex: "9999",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
          transform: "translateY(80px)",
        }}
      >
        {/* Upload Button */}
        <button
          onClick={() => document.getElementById("file-upload").click()}
          style={{
            width: "32px",
            height: "32px",
            backgroundColor: "#fff",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            cursor: "pointer",
            pointerEvents: isUploadDisabled ? "none" : "auto",
            opacity: isUploadDisabled ? 0.5 : 1,
          }}
title={isUploadDisabled ? "Upload disabled — please delete the current shape first" : "Choose a Shapefile to upload"}
        >
          <img src="/upload.png" alt="Upload Icon" style={{ width: "20px", height: "20px" }} />
          <input
            id="file-upload"
            type="file"
            accept=".shp,.kml,.geojson,zip"
            style={{ display: "none" }}
            onChange={handleFileUpload}
            disabled={isUploadDisabled}
            ref={fileInputRef}
          />
        </button>

        {/* Measure Button */}
        <button
          onClick={handleMeasureClick}
          style={{
            width: "32px",
            height: "32px",
            backgroundColor: "#fff",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          title="Measure (toggle show/hide)"
        >
          <img src="/measure.png" alt="Measure Icon" style={{ width: "20px", height: "20px" }} />
        </button>
      </div>

      <>
        {/* ✅ CSS لإخفاء LayersControl بشكل افتراضي */}
        <style>
          {`
      .leaflet-bottom.leaflet-right {
        display: none !important;
      }

      .leaflet-control-layers {
        display: none !important;
      }
    `}
        </style>

        <div
          className={isDrawingNow ? "sobek-drawing-hide-vertices" : ""}
          style={{ height: "100vh", width: "100vw", position: "relative", overflow: "visible" }}
        >
          <MapContainer
            zoomAnimation={false}
            preferCanvas={true}
            fadeAnimation={false}
            markerZoomAnimation={false}
            id="capture-wrapper"
            center={[26.82, 30.8]}
            zoom={5}
            minZoom={2}
            maxBounds={[[-85, -180], [85, 180]]}
            maxBoundsViscosity={1.0}
            whenCreated={handleMapCreated}
            ref={mapRef}
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          >
            <MapInit />
            <MapLoadListener />
            <EdgeMeasureListener />

            {/* ✅✅✅ NEW: numbered point markers while drawing + after */}
            {!isCurrentUploadLayerHidden && Array.isArray(drawingCoordinates) &&
              drawingCoordinates.map((c, idx) => {
                const lat = parseFloat(c.lat);
                const lng = parseFloat(c.lng);
                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
                return (
                  <Marker
                    key={`pt-${idx}`}
                    position={[lat, lng]}
                    icon={getPointNumberIcon(idx + 1)}
                    interactive={false}
                    opacity={1}
                  />
                );
              })}

            {/* ✅✅✅ NEW: segment length bubbles on map (when pressing Measure) */}
            {!isCurrentUploadLayerHidden && Array.isArray(segmentLabels) &&
              segmentLabels.map((s) => {
                const lat = parseFloat(s.lat);
                const lng = parseFloat(s.lng);
                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
                return (
                  <Marker
                    key={s.id}
                    position={[lat, lng]}
                    icon={getSegmentBubbleIcon(s.text)}
                    interactive={false}
                    opacity={1}
                  />
                );
              })}

            
          {/* Circle Radius Line + Label (Measurement) */}
          {isMeasureOn && Array.isArray(circleMeasureLine) && circleMeasureLine.length === 2 && (
            <Polyline
              positions={circleMeasureLine}
              pathOptions={{ color: "#588880", weight: 2, dashArray: "6,6" }}
              interactive={false}
            />
          )}

          {isMeasureOn && circleRadiusLabel && circleRadiusLabel.lat && circleRadiusLabel.lng && (
            <Marker
              position={[circleRadiusLabel.lat, circleRadiusLabel.lng]}
              icon={L.divIcon({
                className: "circle-radius-label",
                html: `<div style="background: rgba(0,0,0,0.75); color: #fff; padding: 6px 14px; border-radius: 8px; font-size: 13px; min-width: 90px; text-align: center; line-height: 1.2; border: 1px solid rgba(245,166,35,0.8); white-space: nowrap;">${circleRadiusLabel.text}</div>`,
              })}
              interactive={false}
            />
          )}

<LayersControl position="bottomright" collapsed={false}>
              <LayersControl.BaseLayer checked name="ArcGIS">
                <TileLayer
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  attribution="Esri, DeLorme, NAVTEQ"
                  eventHandlers={{
                    load: () => {
                      console.log("🎉 TileLayer load event – map is ready");
                      setIsMapReady(true);
                    },
                  }}
                  noWrap={true}
                  bounds={[[-85, -180], [85, 180]]}
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="OpenStreetMap">
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                  eventHandlers={{
                    load: () => {
                      console.log("🎉 TileLayer load event – map is ready");
                      setIsMapReady(true);
                    },
                  }}
                  noWrap={true}
                  bounds={[[-85, -180], [85, 180]]}
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="TopoMap">
                <TileLayer
                  url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenTopoMap contributors"
                  eventHandlers={{
                    load: () => {
                      console.log("🎉 TileLayer load event – map is ready");
                      setIsMapReady(true);
                    },
                  }}
                  noWrap={true}
                  bounds={[[-85, -180], [85, 180]]}
                />
              </LayersControl.BaseLayer>

              {/* ✅✅✅ التعديل الوحيد: شيلنا رسم shapes هنا عشان مايحصلش Duplicate مع FeatureGroup بتاع draw */}
              <LayersControl.Overlay checked name="Drawn Shapes">
                <FeatureGroup>
                  {/* ✅ لا نرسم shapes هنا لأن Leaflet-Draw يرسمها بالفعل داخل FeatureGroup الأساسي */}
                </FeatureGroup>
              </LayersControl.Overlay>
            </LayersControl>

            {markerPosition && (
              <Marker position={markerPosition} icon={pinIcon}>
                <Popup>Selected Location</Popup>
              </Marker>
            )}

            <FeatureGroup ref={featureGroupRef}>
              <EditControl
                position="topright"
                onCreated={handleCreated}
                onMounted={(drawControl) => {
                  drawControlRef.current = drawControl;
                }}
                ref={drawRef}
                draw={{
                  // ✅✅✅ إضافة Rectangle + Circle
                  rectangle: true,
                  circle: true,

                  circlemarker: false,
                  marker: false,
                  polyline: {},
                  polygon: {
                    allowIntersection: false,
                    finishOnDoubleClick: true, // ✅ إنهاء البوليجون بدبل كليك
                  },
                }}
                edit={{ remove: true }}
                onDrawStart={handleDrawStart}
                onDrawStop={() => {
                  setIsDrawingNow(false); // ✅
                  removePolygonDblClickFinish(); // ✅✅✅ مهم
                  try {
                    const _m = mapRef?.current;
                    const _el = _m && _m.getContainer ? _m.getContainer() : document.querySelector(".leaflet-container");
                    if (_el) _el.classList.remove("sobek-hide-line-actions");
                  } catch (e) {}

                }}
                onDrawVertex={handleVertexAdded}
                onEdited={handleEdited}
                onDeleted={handleDeleted}
                onEditStart={handleEditStart}
                onEditStop={handleEditStop}
                onDeleteStart={handleDeleteStart}
                onDeleteStop={handleDeleteStop}
                onDrawDelete={handleDeleteLastPoint} // ربط حذف آخر نقطة هنا
              />
            </FeatureGroup>
          </MapContainer>

          {/* ✅ عناصر UI إضافية */}
          <div style={{ position: "absolute", top: "120px", right: "10px", zIndex: 500, pointerEvents: "none" }}>
            {/* UI غير تفاعلي */}
          </div>
        </div>
      </>

      {/* Unified Popup */}
      {showPopup && (
        <div
          className="sobek-sidepanel sobek-dark-scroll"
          style={{
            position: "fixed",
            top: "70px",
            left: "0",
            height: "calc(100vh - 70px)", // ✅ يأخذ بقية الشاشة تحت الهيدر فقط
            width: "370px",
            backgroundColor: "#333",
            color: "#fff",
            padding: "20px",
            borderRight: "2px solid #444",
            boxShadow: "2px 0 6px rgba(0,0,0,0.3)",
            zIndex: "1000",
            overflowY: "auto",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Tabs */}
          {selectedTab === "details" && (
            <>
              {/* ✅✅✅ CHANGED: title rules */}
              <h4>{detailsTitle}</h4>

              {/* ✅✅✅ Uploaded layers list (show/hide) */}
              {Array.isArray(uploadedMapLayers) && uploadedMapLayers.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                  <div style={{ fontWeight: "bold", marginBottom: "8px", color: "#ff9f00" }}>
                    Uploaded Layers
                  </div>

                  <div style={{ display: "grid", gap: "8px" }}>
                    {uploadedMapLayers.map((g) => (
                    <div
                      key={g.id}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "#1f1f1f",
                        padding: "12px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.4)",
                        marginBottom: "10px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <input
                            type="checkbox"
                            checked={g.visible}
                            onChange={() => toggleUploadedLayerVisibility(g.id)}
                            style={{ width: "18px", height: "18px", cursor: "pointer" }}
                          />

                          <div>
                            <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                              {(g.displayName || g.name || _layerGroupTitle(g.key || g.typeKey))} <span style={{ opacity: 0.7 }}>({(g.count ?? (g.layerIds?.length || 0))})</span>
                            </div>
                            <div style={{ fontSize: "13px", color: "#bbb" }}>
                              {g.visible ? "Visible" : "Hidden"}
                            </div>
                          </div>
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {/* ✅ Arrow to expand details */}
                          <button
                            onClick={() =>
                              setExpandedUploadGroups((prev) => ({
                                ...prev,
                                [g.id]: !prev[g.id],
                              }))
                            }
                            style={{
                              width: "38px",
                              height: "34px",
                              borderRadius: "8px",
                              backgroundColor: "#2c2c2c",
                              border: "1px solid rgba(255,255,255,0.08)",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#fff",
                              fontSize: "16px",
                            }}
                            title={expandedUploadGroups[g.id] ? "Hide details" : "Show details"}
                          >
                            {expandedUploadGroups[g.id] ? "▴" : "▾"}
                          </button>

                          {/* ✅ Trash delete */}
                          <button
                            onClick={() => deleteUploadedLayerGroup(g.id)}
                            style={{
                              width: "38px",
                              height: "34px",
                              borderRadius: "8px",
                              backgroundColor: "#2c2c2c",
                              border: "1px solid rgba(255,255,255,0.08)",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#fff",
                              fontSize: "16px",
                            }}
                            title="Delete layer"
                          >
                            🗑
                          </button>
                        </div>
                      </div>

                      {/* ✅ Expanded info */}
                      {expandedUploadGroups[g.id] && (
                        <div style={{ marginTop: "10px", paddingLeft: "28px" }}>
                          {((g.typeKey || g.key) === "lines") && (
                            <div style={{ marginTop: "6px" }}>
                              <div
                                className="sobek-dark-scroll"
                                style={{
                                  backgroundColor: "#2c2c2c",
                                  padding: "10px",
                                  borderRadius: "8px",
                                  maxHeight: "140px",
                                  overflowY: "auto",
                                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.06)",
                                }}
                              >
                                {(() => {
                                  const fc = buildFeatureCollectionFromUploadedGroup(g);
                                  const lines = (fc.features || []).filter(
                                    (f) =>
                                      f?.geometry?.type === "LineString" ||
                                      f?.geometry?.type === "MultiLineString"
                                  );
                                  if (lines.length === 0) {
                                    return <div style={{ color: "#bbb", fontSize: "13px" }}>No lines</div>;
                                  }
                                  return lines.map((f, idx) => {
                                    const km = _featureLengthKm(f);
                                    return (
                                      <div
                                        key={idx}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          padding: "4px 0",
                                          borderBottom: "1px solid rgba(255,255,255,0.06)",
                                        }}
                                      >
                                        <span style={{ color: "#f5a623", fontWeight: "bold" }}>
                                          Line{idx + 1}:
                                        </span>
                                        <span style={{ color: "rgb(27, 169, 158)", fontSize: "13px" }}>
                                          {Number.isFinite(km) ? km.toFixed(4) : "0.0000"} km
                                        </span>
                                      </div>
                                    );
                                  });
                                })()}

                                <div
                              style={{
                                marginTop: "10px",
                                padding: "12px 10px",
                                background: "#1a1a1a",
                                borderRadius: "8px",
                                textAlign: "center",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.45)",
                              }}
                            >
                              <div style={{ color: "#fff", fontWeight: "bold", fontSize: "18px", marginBottom: "4px" }}>
                                Total Length:
                              </div>
                              <div style={{ color: "#fff", fontWeight: "bold", fontSize: "22px" }}>
                                <span style={{ color: "rgb(27, 169, 158)" }}>{getUploadedGroupTotalLengthKm(g).toFixed(4)}</span> km
                              </div>
                            </div>

                              </div>
                            </div>
                          )}

                          
                {((g.typeKey || g.key) === "polygons") && (
                  <div style={{ marginTop: "10px", padding: "10px", background: "#1a1a1a", borderRadius: "8px" }}>
<div
                      className="sobek-dark-scroll"
                      style={{
                        backgroundColor: "#2c2c2c",
                        padding: "10px",
                        borderRadius: "8px",
                        maxHeight: "140px",
                        overflowY: "auto",
                        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.06)",
                      }}
                    >
                      {(() => {
                        const fc = buildFeatureCollectionFromUploadedGroup(g);
                        const polys = (fc.features || []).filter(
                          (f) => f?.geometry?.type === "Polygon" || f?.geometry?.type === "MultiPolygon"
                        );
                        if (polys.length === 0) {
                          return <div style={{ color: "#bbb", fontSize: "13px" }}>No polygons</div>;
                        }
                        return polys.map((f, idx) => {
                          let km2 = 0;
                          try {
                            km2 = turf.area(f) / 1000000;
                          } catch (e) {
                            km2 = 0;
                          }
                          return (
                            <div
                              key={idx}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "4px 0",
                                borderBottom: "1px solid rgba(255,255,255,0.06)",
                              }}
                            >
                              <span style={{ color: "#f5a623", fontWeight: "bold" }}>
                                Polygon{idx + 1}:
                              </span>
                              <span style={{ color: "rgb(27, 169, 158)", fontSize: "13px" }}>
                                {Number.isFinite(km2) ? km2.toFixed(4) : "0.0000"} km²
                              </span>
                            </div>
                          );
                        });
                      })()}

                    </div>

                    <div
                              style={{
                                marginTop: "10px",
                                padding: "12px 10px",
                                background: "#1a1a1a",
                                borderRadius: "8px",
                                textAlign: "center",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.45)",
                              }}
                            >
                              <div style={{ color: "#fff", fontWeight: "bold", fontSize: "14px", marginBottom: "4px" }}>
                                Total Area:
                              </div>
                              <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>
                                <span style={{ color: "rgb(27, 169, 158)" }}>{getUploadedGroupTotalAreaKm2(g).toFixed(4)}</span> km²
                              </div>
</div>
                  </div>
                )}

{((g.typeKey || g.key) === "points") && (
                            <div
                              className="sobek-dark-scroll"
                              style={{
                                marginTop: "8px",
                                backgroundColor: "#2c2c2c",
                                padding: "10px",
                                borderRadius: "8px",
                                maxHeight: "120px",
                                overflowY: "auto",
                                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.06)",
                              }}
                            >
                              {getUploadedGroupPointCoords(g).length === 0 ? (
                                <div style={{ color: "#bbb", fontSize: "13px" }}>No points</div>
                              ) : (
                                getUploadedGroupPointCoords(g).map((c, idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                      padding: "4px 0",
                                      borderBottom: "1px solid rgba(255,255,255,0.06)",
                                    }}
                                  >
                                   <span style={{ color: "#f5a623", fontWeight: "bold", marginRight: "15px" }}>
  Point {idx + 1}:
</span>

<span style={{ color: "rgb(27, 169, 158)", fontSize: "13px" }}>
  <span style={{ marginRight: "25px" }}>
    X&nbsp;{Number(c[0]).toFixed(6)}
  </span>
  <span>
    Y&nbsp;{Number(c[1]).toFixed(6)}
  </span>
</span>
                                  </div>
                                ))
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                  {false && (uploadedMapLayers.map((g) => (
                      <div
                        key={g.id}
                        style={{
                          backgroundColor: "#2c2c2c",
                          padding: "10px",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          boxShadow: "0px 2px 5px rgba(0,0,0,0.35)",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <input
                            type="checkbox"
                            checked={!!g.visible}
                            onChange={() => toggleUploadedLayerVisibility(g.id)}
                            style={{ transform: "scale(1.1)" }}
                          />
                          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <div style={{ fontWeight: "bold" }}>
                              {g.name}{" "}
                              <span style={{ color: "#bbb", fontWeight: "normal" }}>
                                ({(g.layerIds || []).length})
                              </span>
                            </div>
                            <div style={{ fontSize: "12px", color: "#bbb" }}>
                              {g.visible ? "Visible" : "Hidden"}
                            </div>
                          </div>
                        </div>

                        <button
                          onClick={(e) => { e.stopPropagation(); deleteUploadedLayerGroup(g.id); }}
                          style={{
                            background: "transparent",
                            border: "1px solid #555",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            cursor: "pointer",
                          }}
                          title={g.visible ? "Hide Layer" : "Show Layer"}
                        >
                          {g.visible ? "👁" : "🚫"}
                        </button>
                      </div>
                    )))}
                  </div>
                </div>
              )}

              {/* ✅ Coordinates list: prefer drawing coords while drawing; otherwise show visible points if points visible */}
              {(() => {
                const coordsToShow =
                  // ✅ لما فيه Uploaded Layers: الإحداثيات تبان داخل اللاير نفسها (تحت السهم) مش برّه تحت
                  hasUploadData
                    ? []
                    : Array.isArray(drawingCoordinates) && drawingCoordinates.length > 0
                    ? drawingCoordinates
                    : visibleType === "points"
                    ? visiblePointCoords
                    : [];

                const shouldShowEmpty =
                  !hasUploadData &&
                  !hasDrawData &&
                  (!Array.isArray(drawingCoordinates) || drawingCoordinates.length === 0) &&
                  (!Array.isArray(shapes) || shapes.length === 0);

                return coordsToShow.length > 0 ? (
                  <div style={{ maxHeight: "320px", overflowY: "auto", paddingRight: "6px" }}>
                    <div style={{ display: "grid", gap: "8px" }}>
                      {coordsToShow.map((coord, index) => (
                        <div
                          key={index}
                          style={{
                            backgroundColor: "#2c2c2c",
                            padding: "8px",
                            borderRadius: "5px",
                            boxShadow: "0px 2px 5px rgba(0,0,0,0.5)",
                            fontSize: "13px",
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start", // ✅✅✅ CHANGED: no space-between
                            alignItems: "center",
                            gap: "8px", // ✅✅✅ CHANGED: small gap
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ fontWeight: "bold", color: "#ff9f00" }}>
                            Point {index + 1}:
                          </div>

                          {/* ✅✅✅ CHANGED: reduced spacing between X and Y */}
                          <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                            <strong style={{ color: "#fff" }}>X</strong> <span style={{ color: "rgb(27, 169, 158)", fontWeight: "bold" }}>{coord.lng}</span>
                            <span style={{ marginLeft: "10px" }}>
                              <strong style={{ color: "#fff" }}>Y</strong> <span style={{ color: "rgb(27, 169, 158)", fontWeight: "bold" }}>{coord.lat}</span>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : shouldShowEmpty ? (
                  <p>No data yet. Start drawing or show a points layer.</p>
                ) : null;
              })()}

              {/* ✅✅✅ Visible-based summary */}
              {visibleType === "polygon" && uploadedMapLayers.length === 0 && (
                <>
                  <div
                    style={{
                      marginTop: "10px",
                      padding: "12px 10px",
                      background: "#1a1a1a",
                      borderRadius: "8px",
                      textAlign: "center",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.45)",
                    }}
                  >
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "14px", marginBottom: "4px" }}>
                      Total Area:
                    </div>
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>
                      <span style={{ color: "rgb(27, 169, 158)" }}>{fmtKm2(visibleAreaM2)}</span> km²
                    </div>
                  </div>

                  {visibleCircleRadiusM && (
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "12px 10px",
                        background: "#1a1a1a",
                        borderRadius: "8px",
                        textAlign: "center",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.45)",
                      }}
                    >
                      <div style={{ color: "#fff", fontWeight: "bold", fontSize: "14px", marginBottom: "4px" }}>
                        Radius:
                      </div>
                      <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>
                        <span style={{ color: "rgb(27, 169, 158)" }}>{visibleCircleRadiusM}</span> m
                      </div>
                    </div>
                  )}
                </>
              )}


              {visibleType === "line" && uploadedMapLayers.length === 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    padding: "12px 10px",
                    background: "#1a1a1a",
                    borderRadius: "8px",
                    textAlign: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.45)",
                  }}
                >
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "18px", marginBottom: "4px" }}>
                    Total Length:
                  </div>
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "22px" }}>
                    <span style={{ color: "rgb(27, 169, 158)" }}>{Number.isFinite(visibleTotalLenKm) ? visibleTotalLenKm.toFixed(4) : "0.0000"}</span> km
                  </div>
                </div>
              )}

              {visibleType === "line" && edgeMeasurement && uploadedMapLayers.length === 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    padding: "12px 10px",
                    background: "#1a1a1a",
                    borderRadius: "8px",
                    textAlign: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.45)",
                  }}
                >
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "18px", marginBottom: "4px" }}>
                    Selected Edge:
                  </div>
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "22px" }}>
                    <span style={{ color: "rgb(27, 169, 158)" }}>{edgeMeasurement.lengthKm}</span> km
                    <span style={{ marginLeft: "8px", fontSize: "14px", fontWeight: "bold", color: "#fff" }}>
                      ({edgeMeasurement.lengthM} m)
                    </span>
                  </div>
                </div>
              )}

              {/* Download Button */}
              <button
                onClick={() => {
                  setAllowShareTab(true); // السماح بتفعيل تبويب Filters
                  setSelectedTab("share");
                }}
                disabled={!shapeDetails} // ✅ الزر يتعطل إذا لم توجد بيانات
                style={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: shapeDetails ? "#1ba99e" : "#888",
                  color: "#FFF",
                  border: "none",
                  fontWeight: "bold",
                  cursor: shapeDetails ? "pointer" : "not-allowed",
                  opacity: shapeDetails ? 1 : 0.6,
                  marginTop: "10px",
                }}
              >
                APPLY
              </button>
            </>
          )}

          {/* Share Tab */}
          {selectedTab === "share" && (
            <>
              {/* Start & End Date */}
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
                <div style={{ width: "48%" }}>
                  <label style={{ fontWeight: "bold" }}>Start Date:</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#2c2c2c",
                      padding: "8px",
                      borderRadius: "5px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={openStartDatePicker}
                  >
                    <span>{new Date(startDate).toLocaleDateString("en-GB")}</span>
                    <FontAwesomeIcon icon={faCalendarDays} style={{ width: "16px", height: "16px" }} />
                    <input
                      type="date"
                      ref={startDateRef}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        pointerEvents: "auto",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                </div>

                <div style={{ width: "48%" }}>
                  <label style={{ fontWeight: "bold" }}>End Date:</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#2c2c2c",
                      padding: "8px",
                      borderRadius: "5px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={openEndDatePicker}
                  >
                    <span>{new Date(endDate).toLocaleDateString("en-GB")}</span>
                    <FontAwesomeIcon icon={faCalendarDays} style={{ width: "16px", height: "16px" }} />
                    <input
                      type="date"
                      ref={endDateRef}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        pointerEvents: "auto",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Resolution Slider */}
              <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", width: "100%" }}>
                <label style={{ fontWeight: "bold", marginRight: "32px", color: "#fff", marginTop: "30px" }}>
                  Resolution:
                </label>
                <div
                  style={{ position: "relative", width: "100%", flexGrow: 0.8, marginTop: "30px" }}
                  ref={resolutionSliderRef}
                  onMouseMove={(e) => handleMouseMove(e, "resolution")}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={() => setIsDragging(false)}
                >
                  <input
                    type="range"
                    min="10"
                    max="500"
                    value={resolution}
                    onChange={(e) => setResolution(parseFloat(e.target.value))}
                    style={{
                      width: "100%",
                      height: "8px",
                      background: resolutionBg,
                      borderRadius: "5px",
                      appearance: "none",
                      position: "relative",
                      zIndex: "1",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "-18px",
                      left: `${(resolution / 500) * 100 - 10}%`,
                      transform: "translateX(-50%)",
                      width: "50px",
                      height: "20px",
                      backgroundColor: "#ff9f00",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "12px",
                      borderRadius: "5px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: "2",
                      cursor: "pointer",
                    }}
                    onMouseDown={handleMouseDown}
                  >
                    {resolution < 100 ? `${resolution} cm` : `${(resolution / 100).toFixed(2)} m`}
                  </div>
                </div>
              </div>

              {/* Cloud Cover Slider */}
              <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", width: "100%" }}>
                <label style={{ fontWeight: "bold", marginRight: "20px", color: "#fff" }}>Cloud Cover:</label>
                <div
                  style={{ position: "relative", flexGrow: 1 }}
                  ref={cloudCoverSliderRef}
                  onMouseMove={(e) => handleMouseMove(e, "cloudCover")}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={() => setIsDragging(false)}
                >
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={cloudAverage}
                    onChange={(e) => setCloudAverage(parseFloat(e.target.value))}
                    style={{
                      width: "100%",
                      height: "8px",
                      background: cloudBg,
                      borderRadius: "5px",
                      appearance: "none",
                      position: "relative",
                      zIndex: "1",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "-18px",
                      left: `${(cloudAverage / 100) * 100 - 10}%`,
                      transform: "translateX(-50%)",
                      width: "50px",
                      height: "20px",
                      backgroundColor: "#ff9f00",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "12px",
                      borderRadius: "5px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: "2",
                      cursor: "pointer",
                    }}
                    onMouseDown={handleMouseDown}
                  >
                    {cloudAverage}%
                  </div>
                </div>
              </div>

              {/* Nadir Angle Slider */}
              <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", width: "100%" }}>
                <label style={{ fontWeight: "bold", marginRight: "46px", color: "#fff" }}>Off Nadir:</label>
                <div
                  style={{ position: "relative", width: "65%", flexGrow: 0.8 }}
                  ref={nadirAngleSliderRef}
                  onMouseMove={(e) => handleMouseMove(e, "nadirAngle")}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={() => setIsDragging(false)}
                >
                  <input
                    type="range"
                    min="0"
                    max="90"
                    value={nadirAngle}
                    onChange={(e) => setNadirAngle(parseFloat(e.target.value))}
                    style={{
                      width: "100%",
                      height: "8px",
                      background: nadirBg,
                      borderRadius: "5px",
                      appearance: "none",
                      position: "relative",
                      zIndex: "1",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "-18px",
                      left: `${(nadirAngle / 90) * 100 - 10}%`,
                      transform: "translateX(-50%)",
                      width: "50px",
                      height: "20px",
                      backgroundColor: "#ff9f00",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "12px",
                      borderRadius: "5px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: "2",
                      cursor: "pointer",
                    }}
                    onMouseDown={handleMouseDown}
                  >
                    {nadirAngle}°
                  </div>
                </div>
              </div>

              {/* Data Types */}
              <div style={{ marginBottom: "10px" }}>
                <label style={{ fontWeight: "bold" }}>Data Types:</label>
                {["VHR-Imagery", "HR-Imagery", "DEM", "Multispectral", "SAR-Stereo"].map((type) => (
                  <div key={type} style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                    <input
                      type="checkbox"
                      checked={selectedDataTypes.includes(type)}
                      onChange={() => handleCheckboxChange(type)}
                      style={{ marginRight: "10px" }}
                    />
                    {type}
                  </div>
                ))}
              </div>

              <label>Notes:</label>
              <textarea
                dir="auto"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                style={{
                  width: "95%",
                  padding: "8px",
                  resize: "none",
                  marginBottom: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  marginLeft: "-10px",
                  marginRight: " -10px",
                  textAlign: "start",
                }}
              ></textarea>

              {/* (باقي share tab كما هو عندك بدون تغيير) */}

              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <button
                  className="review-btn-popup"
                  onClick={() => {
                    console.log("🧪 Button clicked");
                    console.log("📍 isMapReady from inside button:", isMapReady);
                    handleDownload();
                  }}
                  style={{
                    padding: "10px",
                    backgroundColor: isMapReady ? "#1ba99e" : "#888",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: isMapReady ? "pointer" : "not-allowed",
                    fontWeight: "bold",
                    width: "30%",
                  }}
                  disabled={!isMapReady}
                >
                  {isMapReady ? "Review " : "Map Not Ready ❌"}
                </button>

                <button
                  onClick={handleSaveAsKMZ}
                  style={{
                    flex: "1",
                    padding: "10px",
                    backgroundColor: "#ff9f00",
                    color: "#FFF",
                    border: "none",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    cursor: "pointer",
                    marginLeft: "1px",
                  }}
                >
                  Save as KMZ
                </button>

                <button
                  onClick={handleSaveAsSHP}
                  style={{
                    flex: "1",
                    padding: "10px",
                    backgroundColor: "#1ba99e",
                    color: "#FFF",
                    border: "none",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Save as SHP
                </button>
              </div>

              <button
                onClick={handleSendEmail}
                style={{
                  padding: "10px",
                  backgroundColor: "#1ba99e",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  width: "100%",
                  marginTop: "10px",
                  marginRight: "10%",
                }}
              >
                Send Email
              </button>
            </>
          )}

          {/* Close Button */}
          <button
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#2c2c2c",
              color: "#FFF",
              border: "none",
              fontWeight: "bold",
              fontSize: "16px",
              cursor: "pointer",
              borderRadius: "5px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
              marginTop: "10px",
              position: "sticky",
              bottom: "12px",
              zIndex: 6,
            }}
            onClick={() => {
              setShowPopup(false);
              setPopupOpen(false);
              setIsDrawingNow(false);
              removePolygonDblClickFinish(); // ✅✅✅ مهم
            }}
          >
            Close
          </button>
        </div>
      )}

      {customAlert && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "20px 30px",
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            borderRadius: "10px",
            zIndex: 9999,
            minWidth: "300px",
            textAlign: "center",
          }}
        >
          <p style={{ color: "#000", fontWeight: "bold" }}>{customAlert}</p>
          <button
            onClick={() => setCustomAlert(null)}
            style={{
              marginTop: "10px",
              backgroundColor: "#1ba99e",
              color: "white",
              border: "none",
              padding: "8px 12px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default Sobek;

// Helper component
function MapInit() {
  const map = useMap();
  const initialized = useRef(false);

  useEffect(() => {
    if (map && !initialized.current) {
      console.log("🌍 Map instance via useMap:", map);
      initialized.current = true;
    }
  }, [map]);

  return null;
}